/* eslint-disable max-len */
import React from 'react';

export const Logo = (props: React.SVGAttributes<never>) => (
  <svg
    fill="none"
    height="30"
    viewBox="0 0 30 30"
    width="30"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2316 9.23944C13.2532 5.03037 15.3685 2.5481 15.3685 2.5481C15.3685 2.5481 17.1817 5.24623 17.0953 9.23944C17.009 13.2326 15.2174 15.8876 15.2174 15.8876C15.2174 15.8876 13.21 13.4485 13.2316 9.23944Z"
      fill="#8ECB5A"
    />
    <path
      d="M16.7742 16.8909C22.6985 13.695 28.6487 13.9548 28.6487 13.9548C28.6487 13.9548 26.7779 18.8657 20.6977 22.9191C13.952 27.4162 7.1084 26.4788 7.1084 26.4788C7.1084 26.4788 10.85 20.0869 16.7742 16.8909Z"
      fill="#FBAC36"
    />
    <path
      d="M3.45892 14.6591C0.390744 5.79548 1.32824 0.852295 1.32824 0.852295C1.32824 0.852295 8.4021 4.09093 12.493 12.4432C16.5839 20.7955 15.0498 28.9773 15.0498 28.9773C15.0498 28.9773 6.52711 23.5227 3.45892 14.6591Z"
      fill="#00C6F5"
    />
    <path
      d="M11.5505 20.8603C12.8145 19.5459 14.471 18.3387 14.5613 18.29C14.5613 18.29 15.0886 20.4432 15.2197 21.9033C15.3509 23.3635 15.3289 25.5062 15.3289 25.5062C15.3289 25.5062 14.6059 25.7671 13.5645 25.9953C12.5231 26.2235 11.696 26.3432 11.696 26.3432C11.696 26.3432 10.7027 25.4829 10.3618 25.142C10.0209 24.8011 9.03809 23.7217 9.03809 23.7217C9.40786 23.2193 10.2865 22.1747 11.5505 20.8603Z"
      fill="#5D8B5B"
    />
    <path
      d="M21.9195 11.5701C25.5333 8.47512 28.3109 8.28442 28.3109 8.28442C28.3109 8.28442 27.7981 11.8577 24.5224 15.3758C21.2468 18.8939 17.5088 19.7277 17.5088 19.7277C17.5088 19.7277 18.3057 14.665 21.9195 11.5701Z"
      fill="#F473B1"
    />
    <path
      d="M25.5684 14.1367C25.2556 14.5466 24.9082 14.9617 24.5224 15.376C21.2468 18.8941 17.5088 19.7279 17.5088 19.7279C17.5088 19.7279 17.7798 18.0059 18.7227 15.9566C21.2951 14.8672 23.7457 14.3655 25.5684 14.1367Z"
      fill="#F55B39"
    />
  </svg>
);

export const LogoAWTG = (props: React.SVGAttributes<never>) => (
  <svg
    fill="none"
    height="26"
    viewBox="0 0 34 26"
    width="34"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 12.9982C0 5.82297 7.6157 0 17.0019 0C26.3881 0 34 5.82297 34 12.9982C34 20.1734 26.3843 26 17.0019 26C7.61946 26 0 20.177 0 12.9982ZM32.8685 13.273H27.1135L27.0083 12.7746H32.8685C32.7069 6.47893 25.8242 1.09937 17.0019 1.09937C8.09685 1.09937 1.12769 6.5852 1.12769 12.9982C1.12769 19.3891 8.07054 24.897 17.0019 24.897C25.7791 24.9006 32.6731 19.5687 32.8685 13.273Z"
      fill="#228DC1"
    />
    <path
      d="M5.53711 19.4551L8.46912 5.52979H9.24723H25.486L25.5725 5.93289H9.16077L6.31522 19.4551H5.53711Z"
      fill="#228DC1"
    />
    <path
      d="M8.46484 5.52979L11.3969 19.4551H15.6032L12.6711 5.52979H8.46484Z"
      fill="#6ABE4A"
    />
    <path
      d="M15.4756 5.52979L18.4076 19.4551H22.6139L19.6819 5.52979H15.4756Z"
      fill="#8E3D8C"
    />
    <path
      d="M21.2793 5.52979L24.2113 19.4551H28.4176L25.4856 5.52979H21.2793Z"
      fill="#CC3361"
    />
  </svg>
);

export const LogoLimerick = (props: React.SVGAttributes<never>) => (
  <svg
    fill="none"
    height="30"
    viewBox="0 0 36 30"
    width="36"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.9824 6.27175C13.9824 5.48289 14.2193 4.71175 14.6631 4.05583C15.1069 3.39992 15.7376 2.8887 16.4756 2.58682C17.2136 2.28493 18.0257 2.20594 18.8091 2.35984C19.5925 2.51374 20.3122 2.89362 20.877 3.45142C21.4418 4.00923 21.8265 4.71992 21.9823 5.49363C22.1382 6.26733 22.0582 7.06929 21.7525 7.7981C21.4468 8.52691 20.9292 9.14984 20.265 9.58811C19.6008 10.0264 18.82 10.2603 18.0212 10.2603C16.95 10.2603 15.9228 9.84008 15.1653 9.09208C14.4079 8.34408 13.9824 7.32958 13.9824 6.27175Z"
      fill="#009D57"
    />
    <path
      clipRule="evenodd"
      d="M0 0C0 0 17.3986 10.8685 19.5121 13.8909C19.5121 13.8909 18.8946 10.777 20.2793 10.7305C21.6641 10.684 24.8643 11.4347 35.8696 22.3933C35.8696 22.3933 26.8765 13.4768 24.1541 15.8331C21.4316 18.1893 25.7812 30 25.7812 30C25.7812 30 21.2904 16.257 0 0.00140976V0Z"
      fill="#009D57"
      fillRule="evenodd"
    />
  </svg>
);

export const LogoLimerickFull = (props: React.SVGAttributes<never>) => (
  <svg
    fill="none"
    height="39"
    viewBox="0 0 188 39"
    width="188"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3552_36768)">
      <path
        clipRule="evenodd"
        d="M88.3639 12.2835C88.5784 12.3428 88.7887 12.4187 88.9931 12.5105C89.0005 13.047 88.9301 13.5813 88.7845 14.0943V17.5437C88.9549 17.591 89.131 17.6102 89.3068 17.6004C89.7867 17.2031 91.1722 17.042 91.8743 17.2031C91.9171 17.333 91.9523 17.4657 91.9794 17.6004C91.7725 17.7176 91.4368 17.7194 91.0891 17.7121C90.772 17.919 90.2531 17.8037 89.8834 17.9392C89.3645 18.1222 89.1152 18.4097 88.7845 18.7869C88.7709 21.2421 89.239 23.2817 89.0982 25.6875C88.9659 25.7974 88.966 25.8962 88.7845 25.9695C88.1248 26.473 88.0689 25.3928 88.1062 24.838C87.9027 24.4718 88.1469 23.723 88.0536 23.2543C87.9603 22.7856 88.1112 22.0495 88.001 21.5021C87.8687 20.8338 87.9061 19.9733 87.7924 19.3526C87.6907 19.316 87.5843 19.2969 87.477 19.2959C87.2732 19.6687 86.9921 19.9854 86.6558 20.2212C86.3195 20.4569 85.9371 20.6052 85.5387 20.6544C85.4946 20.4698 85.4774 20.2789 85.4878 20.0886L86.3256 19.1823C86.7088 18.9004 87.1463 18.7777 87.477 18.45C87.6008 18.3255 87.6686 18.1241 87.7924 17.9977V14.0375C87.6753 13.5965 87.6395 13.1349 87.6873 12.679C87.8094 12.5966 87.9298 12.4007 88.0536 12.3403C88.1774 12.2798 88.2876 12.3421 88.3639 12.2835Z"
        fill="#009D57"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0.420563 13.5853C0.671749 13.5969 0.919361 13.6539 1.15316 13.7537C1.44314 14.4 1.37531 15.8043 1.20573 16.6392C1.11076 17.1024 1.20573 17.767 1.15316 18.1643C1.06837 18.7759 1.20573 20.2534 1.31087 20.7661V21.5588C1.56185 22.7855 1.51945 24.2722 1.51945 25.7424C1.32359 25.8406 1.1068 25.8798 0.892 25.856C0.808905 25.7186 0.642715 25.5978 0.576578 25.4605C0.344251 24.9716 0.432434 24.1788 0.315422 23.5948V22.4633C0.201802 21.8939 0.344251 21.1524 0.210281 20.4841C0.0322207 19.5943 0.105141 18.4207 0.105141 17.3716C0.105141 16.7509 0.0576578 15.9746 0.157711 15.4491C0.247589 14.9804 0.00339163 14.4696 0 13.8654C0.146084 13.7828 0.286616 13.6891 0.420563 13.5853V13.5853Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M48.348 13.7537C48.2767 16.2804 48.2067 18.8064 48.1377 21.3318H48.2954C48.4463 21.0755 48.7075 20.8942 48.8703 20.6544C49.0941 20.3266 49.2264 19.9678 49.4469 19.6364C49.6029 19.4002 49.8623 19.186 50.0234 18.9571C50.2676 18.6074 50.5135 18.1644 51.0189 18.1094C51.1969 17.9776 51.6684 18.0637 51.8566 18.1094V18.2211C51.899 18.2889 51.8973 18.3163 51.9092 18.4481C51.1681 19.1805 49.9878 20.2186 49.4469 21.1066C49.262 21.4105 48.9144 22.1008 49.1857 22.5201C49.6351 24.08 53.5185 23.2671 53.5847 25.1218C52.2636 25.1474 51.3801 24.5835 50.4423 24.1587C50.171 24.0361 49.9454 24.0489 49.6571 23.9335C49.2586 23.7742 48.6753 23.5673 48.1903 23.6497C48.0512 24.0159 48.2089 24.1606 48.2954 24.4993C48.3988 24.9094 48.2445 25.4037 48.1903 25.6875C48.0327 25.7847 47.8579 25.8448 47.6773 25.864C47.4967 25.8833 47.3144 25.8612 47.1422 25.7992L47.0371 25.6875C47.1813 25.2078 46.9761 24.4901 47.0897 23.9335C47.2813 23.0016 46.9625 21.7749 47.1422 20.7661C47.2813 19.9916 47.0676 18.8052 47.2474 17.5437V15.5645C47.2084 15.4272 47.1032 15.3283 47.0897 15.1122C47.0659 14.7131 47.0371 14.0906 47.1948 13.8672C47.4356 13.6237 47.9478 13.6951 48.348 13.7537Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M93.4463 21.1066C94.0296 21.0499 94.3179 20.5409 94.6503 20.2003C95.2608 19.5742 96.2138 18.4665 97.3212 18.4482C97.4128 18.5452 97.467 18.5324 97.5315 18.6734C97.5835 19.6169 97.6355 20.5598 97.6875 21.5021C97.9005 22.6333 98.1838 23.7478 98.5354 24.838C98.7152 25.3635 99.1001 25.8615 99.0068 26.4858C98.7355 26.5792 98.5642 26.6689 98.22 26.5993C97.1041 24.6805 96.8752 22.4578 96.5445 19.6419H96.3868C96.2427 19.836 96.0476 19.8891 95.8628 20.0374C95.2303 20.5281 93.9872 21.6541 93.7685 22.5256C93.6345 23.0565 93.9381 23.6864 94.0296 24.0525C94.1568 24.5158 94.1297 25.0119 94.1348 25.5795C93.9177 25.726 93.6989 25.7626 93.297 25.748C92.8731 24.979 93.0528 23.7083 92.8256 22.694C92.5712 21.5625 92.5017 20.2223 92.249 19.0762C92.0947 18.3694 92.2321 17.6114 92.0913 16.9267C92.1094 15.9844 92.1269 15.0421 92.1439 14.0998C92.3389 13.9551 92.3338 13.8361 92.6679 13.816C92.7464 13.8749 92.8363 13.9137 92.9307 13.9295C93.0308 14.0961 93.2377 14.2407 93.297 14.4385C93.4412 14.9182 93.2105 15.581 93.1393 15.9032V18.6184C93.285 19.4409 93.3875 20.2716 93.4463 21.1066V21.1066Z"
        fill="#009D57"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.98121 14.1492C6.17914 14.1202 6.38048 14.16 6.55609 14.2627C6.68218 14.2977 6.79308 14.379 6.8698 14.4925C6.94652 14.6061 6.9843 14.7449 6.97665 14.8852C6.65615 15.1031 6.40177 15.1745 5.8235 15.1672C5.75567 15.0647 5.72005 15.072 5.66579 14.942C5.56913 14.79 5.63187 14.5392 5.66579 14.3762C5.77926 14.315 5.88522 14.2387 5.98121 14.1492V14.1492Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M37.1386 14.1492C37.3672 14.1665 37.5941 14.2044 37.8169 14.2627C37.9076 14.4241 38.0127 14.5755 38.1306 14.715C38.0984 14.8157 38.1221 14.7699 38.0797 14.8285C37.9763 14.9914 37.8372 15.0372 37.7118 15.1672C37.4315 15.1779 37.151 15.1595 36.874 15.1123C36.8293 15.0423 36.7939 14.9659 36.7689 14.8852C36.662 14.7021 36.7689 14.5062 36.8215 14.3195L36.9792 14.2627C37.0148 14.2243 37.0979 14.1895 37.1386 14.1492Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M139.067 14.1492C139.296 14.1664 139.523 14.2044 139.746 14.2627C139.881 14.4806 139.992 14.5062 140.007 14.8852L139.641 15.1672C139.36 15.1779 139.08 15.1595 138.803 15.1123C138.712 14.9001 138.676 14.6655 138.698 14.433C138.74 14.3744 138.716 14.4165 138.75 14.3195L138.908 14.2627C138.952 14.2243 139.028 14.1895 139.067 14.1492Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.38083 14.6582L8.90484 14.7149C8.92349 14.7717 8.94045 14.8284 8.95741 14.8852C9.21518 15.2514 8.97776 15.634 8.85397 15.9599C8.81892 16.4872 8.78387 17.0152 8.74883 17.5437C8.54872 19.8543 8.40966 22.1209 8.8014 24.1587H8.90484C9.05238 23.4795 9.41359 22.6793 9.63913 22.0111C10.1207 20.583 10.4006 19.1713 10.9958 17.9391C11.1654 17.573 11.7708 16.2511 12.4101 16.6941C12.695 16.7893 12.8001 17.009 12.9867 17.2031C12.9307 18.9425 12.8866 20.8961 13.3004 22.2363C13.4361 22.6775 13.4819 23.3348 13.8244 23.538V23.5948L13.877 23.538C14.2484 23.1719 14.4417 22.348 14.6621 21.8408C15.1234 20.7734 15.7729 19.7078 16.3376 18.7283C16.7039 18.0966 16.9515 17.1354 17.9096 17.1464C17.9639 17.1903 17.9232 17.1647 18.0148 17.2013C18.164 17.6847 18.0707 18.5378 18.0673 19.1256L18.2759 21.7254C18.5473 22.8679 19.112 23.7394 19.3765 24.838C19.5037 25.3634 19.2663 25.5703 18.8525 25.5703C18.6507 25.3543 18.3828 25.2042 18.2234 24.9478C17.9486 24.4938 17.93 23.9939 17.7519 23.4209C17.3517 22.1228 17.1787 20.7679 17.177 19.1237C17.11 19.0935 17.0391 19.0744 16.9668 19.067C16.8175 19.5577 16.324 19.9953 16.0765 20.4237C15.4879 21.4724 15.0634 22.6186 14.8199 23.8163C14.6265 24.7043 14.752 25.9786 13.877 26.0793C13.8103 26.1177 13.7342 26.1328 13.6592 26.1226C13.5842 26.1125 13.514 26.0775 13.4581 26.0226C12.5339 25.0064 12.3626 21.5918 11.9912 19.8579C11.8623 19.2629 11.9522 18.6807 11.7809 18.1607L11.7284 18.2174C11.2654 18.5836 11.162 19.3361 10.9432 19.9714C10.4345 21.4362 10.0953 23.1938 9.63404 24.7208C9.42207 25.4184 9.27622 26.9399 8.53346 26.9838C8.3927 26.8355 8.24517 26.8172 8.16716 26.5883C7.88396 26.1123 7.99758 24.9753 7.85343 24.3253C7.57702 23.0217 7.48375 20.8246 7.74829 19.5192V17.8348C7.90431 17.0658 7.69572 16.2401 7.80086 15.6377C7.84654 15.4708 7.88167 15.3008 7.906 15.1287C8.06711 14.9804 8.22312 14.8065 8.38083 14.6582Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M136.186 16.9193H136.502C136.626 17.0974 136.682 17.3202 136.659 17.5418C134.989 18.774 133.664 21.828 132.677 23.8749C132.491 24.2631 132.294 24.6952 132.153 25.0632C131.919 25.6784 132.092 26.451 131.368 26.5279C131.187 26.6634 130.888 26.5407 130.739 26.4711C130.458 25.9036 130.4 25.2316 130.164 24.5487C129.745 23.3165 129.498 21.9854 129.064 20.7038C128.938 20.3376 128.853 19.8744 128.697 19.4606C128.484 18.8949 128.189 18.5873 128.173 17.7634C128.257 17.73 128.345 17.7109 128.435 17.7066C128.604 17.8311 129.07 17.822 129.325 17.8201C129.581 18.3474 129.598 18.9974 129.796 19.6309C130.115 20.6416 130.351 21.8683 130.687 22.8533C130.839 23.3 130.98 24.4352 131.365 24.5505C131.84 23.6351 132.43 22.7672 132.937 21.8921C133.971 20.1106 134.818 18.3291 136.186 16.9193Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M110.259 16.9779C110.459 17.1299 110.428 17.3441 110.364 17.6554C109.631 18.0325 108.415 18.8802 108.059 19.6364H108.164C108.549 19.8451 109.433 19.4039 109.787 19.2959C111.037 18.9132 112.346 19.3251 112.721 20.2571C113.569 22.3553 111.219 24.5176 110.103 25.1767C109.825 25.3415 108.699 26.0683 108.217 25.7424C107.924 25.6454 107.878 25.4349 107.693 25.2335C107.691 25.0621 107.709 24.8912 107.745 24.7245H107.851C108.093 24.578 108.817 24.9552 109.316 24.7812C109.965 24.5591 110.551 24.1622 111.018 23.6279C111.486 23.0935 111.82 22.4395 111.988 21.7273C112.105 21.1982 111.863 20.7771 111.778 20.4273C110.484 19.5119 109.258 20.204 108.112 20.7093C107.745 20.8723 106.74 21.2586 106.436 20.8796C106.041 20.3083 106.696 19.6547 106.906 19.3526C107.464 18.5562 108.432 17.8549 109.263 17.3734C109.568 17.1976 109.97 17.1867 110.259 16.9779Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M76.3696 17.3734L77.2073 17.4302C77.2527 17.4991 77.2882 17.575 77.3124 17.6554C77.4651 17.941 77.2463 18.7539 77.1564 19.0707C76.7274 20.5885 76.4018 21.947 77.0513 23.5948C77.2209 24.0232 77.3413 24.6018 77.8364 24.6695C78.4351 25.054 79.3983 24.1551 79.6696 23.9372C80.8024 23.0089 81.3213 21.1286 81.9217 19.6401C82.1777 19.0066 82.3744 17.6865 83.0748 17.6041C83.1613 17.5565 83.2105 17.5895 83.3885 17.6041C83.4394 17.7542 83.4564 17.7011 83.4937 17.8861C83.8413 18.472 83.2071 20.0319 83.3885 20.94C83.5293 21.6431 83.4903 22.3956 83.7023 23.0327C83.9261 23.6992 84.3687 24.3144 84.5417 25.0119C84.6672 25.5246 84.4654 25.7846 84.0703 25.8029C83.2851 24.8709 82.8527 23.6552 82.4982 22.2399C82.3795 21.7694 82.4728 21.2989 82.3405 20.8832C82.249 20.9199 82.2897 20.8942 82.2371 20.94C81.808 21.4655 81.6927 22.315 81.3468 22.9192C80.8249 23.8858 80.1086 24.7136 79.2508 25.3415C78.9879 25.5246 77.8195 26.1214 77.2599 25.737C76.2576 25.3946 76.0321 24.0599 75.793 22.8533V21.1561C75.5335 19.8286 75.8371 18.0911 76.3696 17.3734Z"
        fill="#009D57"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M22.4185 23.4245C22.4524 22.6537 23.0392 22.3132 23.3614 21.8408C23.9736 20.9491 24.272 20.4035 24.2517 18.9571C24.1749 18.9115 24.1047 18.8541 24.0431 18.7869C23.7039 18.7869 23.3834 18.7704 23.1528 18.9004C22.2286 19.4203 21.1178 21.9104 21.5808 23.7065C21.9691 25.184 23.263 25.8743 25.0385 25.856C25.0199 25.9695 25.0029 26.083 24.986 26.1965C24.7409 26.3696 24.4666 26.4887 24.1787 26.5468C23.8909 26.6049 23.5952 26.601 23.3088 26.5352C21.5757 26.0995 21.0398 25.3854 20.6379 23.538C20.5412 23.0876 20.6752 22.4798 20.743 22.1813C21.0551 20.8173 21.228 19.7279 21.8436 18.7301C22.1302 18.2669 22.6729 17.6682 23.2003 17.4869C23.9244 17.2379 25.0657 17.6187 25.2353 18.1643C25.5151 18.6221 25.2488 19.5412 25.1301 19.9183C24.7129 21.2842 24.0397 23.4447 22.4185 23.4245Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M117.017 17.4302C117.709 17.4118 118.594 17.6645 118.797 18.1625V19.4075C118.592 19.7554 118.641 20.2589 118.483 20.6525C118.066 21.6815 117.242 23.43 115.916 23.4227C115.899 23.3659 115.882 23.3092 115.863 23.2524C116.062 23.0162 116.16 22.661 116.335 22.4047C117.098 21.2915 117.741 20.9693 117.749 18.9553C117.49 18.8169 117.2 18.7581 116.911 18.785C116.499 19.1897 116.013 19.294 115.707 19.8598C114.909 21.3355 114.617 24.1239 115.969 25.1694C116.401 25.5063 116.986 25.6436 117.593 25.7919C117.88 25.8633 118.39 25.737 118.534 25.9622C118.441 26.0848 118.365 26.2386 118.273 26.3576C115.824 27.4818 113.471 24.8105 114.188 21.947C114.553 20.4823 114.977 18.7228 115.969 17.9318C116.193 17.7467 116.439 17.5946 116.701 17.4796C116.827 17.4411 116.937 17.4833 117.017 17.4302Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M150.643 23.4245C150.662 22.5988 151.298 22.229 151.639 21.7273C152.191 20.9162 152.551 20.171 152.425 18.9004C152.17 18.8183 151.905 18.78 151.639 18.7869C151.511 18.9095 151.318 18.9041 151.167 19.0139C150.743 19.3215 150.328 20.0063 150.121 20.5409C149.986 20.9651 149.88 21.3996 149.805 21.8408C149.168 24.6055 151.021 25.8688 153.211 25.856V26.1398C151.264 27.5367 149.376 25.7516 148.915 23.9903C148.745 23.3586 149.02 22.3425 148.915 21.8976H148.862C148.774 22.5475 148.276 22.9833 147.92 23.3623C146.927 24.4686 145.68 25.2694 144.306 25.682C143.095 26.0372 141.728 25.4074 141.269 24.719C139.783 22.5054 141.099 17.2251 143.887 17.9337C144.143 18.3401 144.542 19.6218 144.253 20.1399C144.17 20.3962 143.99 20.4237 143.834 20.5921H143.258C142.993 20.1637 142.749 19.7444 142.892 19.0084H142.786C142.617 19.23 142.31 19.3361 142.159 19.5742C141.865 20.0812 141.652 20.6384 141.53 21.222C141.118 22.9815 141.905 24.3125 142.886 24.7849C143.112 24.8929 143.251 24.827 143.516 24.8984C143.722 24.9552 144.077 25.0943 144.406 25.0119C146.539 24.4718 147.845 22.6849 148.805 20.8833L148.963 20.94C148.986 21.0385 149.021 21.1333 149.068 21.222H149.12C149.181 19.9934 150.326 18.0087 151.155 17.6041C151.881 17.2526 153.25 17.5254 153.512 18.168V19.3563L153.158 20.7642C152.768 21.7603 151.918 23.4319 150.643 23.4245Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.50565 17.7121C4.66472 17.6886 4.82671 17.7081 4.97708 17.7689C5.17889 17.8421 5.21111 17.9721 5.34338 18.1094C5.34338 19.1457 4.98387 19.5229 4.7668 20.2571C4.63114 20.7185 4.6481 21.2879 4.55822 21.7218C4.21905 23.4062 5.1314 24.3052 5.18567 25.5117C5.09433 25.5834 4.98482 25.623 4.87194 25.6253C4.65149 25.8083 4.25806 25.7278 4.03421 25.6253C3.05233 23.9884 3.45254 18.9828 4.50565 17.7121Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M27.552 17.7121C27.8523 17.7036 28.1522 17.7419 28.4424 17.8256C28.4763 17.9245 28.4525 17.8806 28.4949 17.9392V21.1615C28.5136 21.2 28.5305 21.2384 28.5475 21.2751L28.7052 21.2183C28.8002 20.6471 29.2224 20.2589 29.4904 19.8616C30.3586 18.58 31.3558 17.8623 33.4722 17.8824C33.6994 18.2486 33.9707 18.3969 33.9945 19.0139C33.9278 19.0435 33.8576 19.0626 33.7859 19.0707C33.4111 18.6239 32.8244 18.6587 32.0053 18.6733C31.6932 18.9278 31.2235 18.9553 30.9047 19.1823C30.0568 19.7902 29.4565 20.973 29.1241 22.1246C28.9358 22.7746 28.9443 23.5289 28.8103 24.2155C28.7544 24.4956 28.9426 24.816 28.8103 25.065C28.7509 25.2253 28.6501 25.3637 28.5199 25.464C28.3898 25.5643 28.2357 25.6221 28.0761 25.6308C27.9268 25.4916 27.7962 25.3744 27.6572 25.2335C27.6657 23.939 27.7708 22.7361 27.552 21.6724C27.5351 21.2757 27.5176 20.8796 27.4995 20.4841C27.3299 19.717 27.101 18.8619 27.2909 17.9392C27.3866 17.8758 27.4743 17.7995 27.552 17.7121V17.7121Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M35.619 17.7121H36.1431C36.2448 17.8549 36.3381 17.8549 36.4042 18.0527C36.7434 18.5342 36.177 19.5943 36.0379 20.0319C35.7513 20.929 35.4783 22.5585 35.7768 23.6497C35.9463 24.2576 36.2974 24.8197 36.3516 25.5173L36.1956 25.574C35.9124 25.8029 35.4613 25.7223 35.1476 25.6308C35.0442 25.3159 34.8254 25.0229 34.7287 24.6695C34.5574 23.8523 34.5395 23.0062 34.6762 22.1814C34.6931 21.7273 34.7106 21.2745 34.7287 20.8228C34.9967 19.554 35.0594 18.6312 35.619 17.7121Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M120.997 17.7121C121.314 17.7044 121.631 17.7426 121.94 17.8256V21.2183L121.992 21.2751H122.097C123.115 19.3544 124.117 17.8641 126.968 17.8824C127.185 18.2358 127.449 18.45 127.492 19.0139C127.425 19.0433 127.355 19.0624 127.283 19.0707C126.807 18.6074 126.413 18.6569 125.501 18.6734C125.162 18.9535 124.636 18.9773 124.297 19.2391C122.872 20.3376 122.358 22.4011 122.358 25.065C122.065 25.3232 122.069 25.6143 121.521 25.6308C121.456 25.5843 121.386 25.5462 121.312 25.5173C120.973 24.8563 121.341 23.6955 121.154 22.802C121.029 22.1997 121.121 21.416 120.997 20.7661C120.919 20.3541 120.754 19.5906 120.63 19.0707C120.53 18.6496 120.712 18.3237 120.736 17.9959L120.997 17.7121Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M137.55 17.7121H138.072C138.185 17.8713 138.308 18.0224 138.44 18.1644C138.44 19.0652 138.101 19.3947 137.916 20.0319C137.678 20.8155 137.701 21.936 137.6 22.6885C137.482 23.5893 138.411 25.0064 138.23 25.4605C138.162 25.5996 138.252 25.4989 138.124 25.574C137.914 25.7571 137.478 25.7571 137.182 25.6875C137.027 25.4385 136.814 25.206 136.71 24.8947C136.5 24.2594 136.454 22.9906 136.607 22.2363V21.4453C136.934 19.8671 136.834 18.8821 137.55 17.7121Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M41.2236 17.8348C41.4717 17.8325 41.7187 17.8707 41.9562 17.9483C42.3496 18.6129 42.3293 19.1439 42.3225 20.2662C42.1858 20.3909 42.0277 20.4852 41.8571 20.5437C41.6866 20.6021 41.507 20.6236 41.3287 20.6068C41.1897 20.3633 40.9896 20.1307 40.9082 19.814C40.8268 19.4972 41.0099 19.2263 40.8047 19.0816C40.2638 19.6309 39.8839 20.0941 39.6516 21.0041C39.0767 23.2597 40.0331 24.4828 41.5899 24.9057C42.0705 25.044 42.5762 25.044 43.0568 24.9057C44.5711 24.3674 46.1974 22.3516 46.8808 20.8906C47.0962 21.0407 47.1047 21.2256 47.0894 21.6229C47.0046 21.7438 47.0555 21.8499 46.9843 22.0184C46.8216 22.358 46.6291 22.6798 46.4094 22.9796C45.6463 24.0873 43.9623 25.1913 42.5853 25.6381C41.773 25.8999 40.5843 25.7296 40.0179 25.3543C37.9829 24.0049 38.6019 20.5445 39.8093 18.7942C40.0553 18.4702 40.3578 18.2015 40.6996 18.0032C40.8692 17.9044 41.0744 17.9318 41.2236 17.8348Z"
        fill="#231F20"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M70.7611 17.6517H72.9657C73.1573 18.2889 73.5711 18.8857 73.8034 19.5192C73.934 19.8762 73.873 20.1454 73.9594 20.5372C74.4682 22.8423 73.6457 24.8087 72.3891 25.7388C71.9329 26.0775 71.0104 26.6689 70.0845 26.418C68.8126 26.0738 68.1292 24.5579 68.5125 22.6848V22.1209C69.0348 20.0447 69.8284 19.175 70.7611 17.6517ZM72.752 18.5012C73.3913 18.7448 73.5999 21.1835 73.3812 22.2326C72.9352 24.3839 72.5807 25.552 70.1337 25.4001C69.8691 25.1273 69.5351 24.9643 69.3994 24.5524C68.8313 22.8222 69.7979 19.8817 70.6051 19.2428C71.1003 18.8473 71.7922 18.7777 72.3332 18.395C72.4816 18.3747 72.6318 18.4138 72.7554 18.5049L72.752 18.5012Z"
        fill="#009D57"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M65.3179 33.3773C65.3234 32.3617 65.4645 31.3523 65.7368 30.3801C65.9284 29.6478 65.8843 29.0399 66.0505 28.2874C66.1302 27.934 66.3795 26.4254 66.1556 26.0262C65.9623 25.4422 65.072 25.0778 64.6294 24.7245C64.1376 24.3235 63.695 23.6772 63.3202 23.1426C62.53 22.0092 61.2174 20.9565 61.0156 19.2391C61.2717 19.1457 61.7245 19.1787 62.0636 19.1823C62.1179 19.2281 62.0789 19.2025 62.1688 19.2391C62.2536 19.8854 62.7284 20.4072 63.0065 20.8869C63.6679 22.0111 64.8227 24.2173 66.254 24.3931C66.9408 23.4923 66.3337 19.9385 66.3591 18.9004L66.8832 18.4482C67.2223 18.558 67.5021 18.5342 67.6157 18.9004C67.7548 19.0945 67.7972 19.8854 67.7209 20.2571C67.5336 21.2249 67.428 22.2091 67.4055 23.1975L67.3546 24.3858C67.419 24.697 67.7124 25.1602 67.5632 25.6308C67.5072 25.8139 67.2613 25.975 67.1969 26.1398C67.007 26.6213 67.0697 27.4562 66.9357 28.0054C66.5457 29.5892 66.4812 31.605 66.1489 33.207C65.9386 33.3553 65.7198 33.3865 65.3179 33.3773Z"
        fill="#009D57"
        fillRule="evenodd"
      />
      <path
        d="M161.973 8.15299C161.973 7.12747 162.254 6.12498 162.782 5.2723C163.31 4.41961 164.06 3.75502 164.937 3.36258C165.815 2.97013 166.781 2.86744 167.712 3.06751C168.644 3.26758 169.499 3.76142 170.171 4.48657C170.843 5.21172 171.3 6.13561 171.485 7.14143C171.671 8.14724 171.576 9.18979 171.212 10.1372C170.849 11.0847 170.233 11.8945 169.443 12.4642C168.654 13.034 167.725 13.3381 166.775 13.3381C165.501 13.3381 164.28 12.7918 163.379 11.8194C162.479 10.847 161.973 9.52816 161.973 8.15299V8.15299Z"
        fill="#009D57"
      />
      <path
        clipRule="evenodd"
        d="M145.347 0C145.347 0 166.036 14.1291 168.549 18.0582C168.549 18.0582 167.815 14.01 169.461 13.9496C171.108 13.8892 174.913 14.8651 188 29.1113C188 29.1113 177.306 17.5199 174.069 20.583C170.831 23.6461 176.004 39 176.004 39C176.004 39 170.664 21.1341 145.347 0.00183269V0Z"
        fill="#009D57"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_3552_36768">
        <rect
          fill="white"
          height="39"
          width="188"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UploadFileIcon = (props: React.SVGAttributes<never>) => (
  <svg
    fill="none"
    height="48"
    viewBox="0 0 54 48"
    width="54"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1265_454)">
      <path
        d="M41.9035 14.0177C40.0854 5.90814 31.449 0.686818 22.6137 2.35555C15.0481 3.78451 9.60753 9.88255 9.57282 16.972C9.57282 17.3098 9.58803 17.6556 9.6207 18.0214C4.23845 18.5443 0.33709 22.973 0.906808 27.9131C1.43488 32.4921 5.64503 35.9657 10.6616 35.9612H11.8049C11.7788 35.6294 11.7505 35.2996 11.7505 34.9617C11.7505 27.7861 18.0881 21.9691 25.9059 21.9691C33.7237 21.9691 40.0611 27.7861 40.0611 34.9617C40.0611 35.2995 40.0329 35.6293 40.0067 35.9612H41.15C47.7578 35.9777 53.1291 31.0745 53.1472 25.0095C53.1645 19.1899 48.2326 14.3684 41.9035 14.0177Z"
        fill="#B7DFA3"
      />
      <path
        d="M25.9063 45.9551C32.5213 45.9551 37.8838 41.0331 37.8838 34.9614C37.8838 28.8898 32.5213 23.9678 25.9063 23.9678C19.2912 23.9678 13.9287 28.8898 13.9287 34.9614C13.9287 41.0331 19.2912 45.9551 25.9063 45.9551Z"
        fill="#6FBE46"
      />
      <path
        d="M30.2618 35.9618H21.5508C20.9495 35.9618 20.4619 35.5143 20.4619 34.9623C20.4619 34.4104 20.9495 33.9629 21.5508 33.9629H30.2618C30.8631 33.9629 31.3507 34.4104 31.3507 34.9623C31.3507 35.5143 30.8632 35.9618 30.2618 35.9618Z"
        fill="#FAFAFA"
      />
      <path
        d="M25.9063 39.9592C25.3049 39.9592 24.8174 39.5117 24.8174 38.9597V30.9643C24.8174 30.4123 25.3049 29.9648 25.9063 29.9648C26.5077 29.9648 26.9952 30.4123 26.9952 30.9643V38.9597C26.9951 39.5117 26.5077 39.9592 25.9063 39.9592Z"
        fill="#FAFAFA"
      />
    </g>
    <defs>
      <clipPath id="clip0_1265_454">
        <rect
          fill="white"
          height="48"
          transform="translate(0.851562)"
          width="52.2957"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ChevronDownIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const ChevronUpIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="8"
      viewBox="0 0 14 8"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ChevronLeftIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.7105 6.71001C14.3205 6.32001 13.6905 6.32001 13.3005 6.71001L8.71047 11.3C8.32047 11.69 8.32047 12.32 8.71047 12.71L13.3005 17.3C13.6905 17.69 14.3205 17.69 14.7105 17.3C15.1005 16.91 15.1005 16.28 14.7105 15.89L10.8305 12L14.7105 8.12001C15.1005 7.73001 15.0905 7.09001 14.7105 6.71001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ChevronRightIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.29055 6.70999C8.90055 7.09999 8.90055 7.72999 9.29055 8.11999L13.1705 12L9.29055 15.88C8.90055 16.27 8.90055 16.9 9.29055 17.29C9.68055 17.68 10.3105 17.68 10.7005 17.29L15.2905 12.7C15.6805 12.31 15.6805 11.68 15.2905 11.29L10.7005 6.69999C10.3205 6.31999 9.68055 6.31999 9.29055 6.70999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TimesIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {

  const { strokeWidth = '2', ...restProps } = props;
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const CirclePlusIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 22 22"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M11 7V15M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const CircleMinusIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 22 22"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const CircleRemoveIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 22 22"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const IconLogOut = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.16667 3.5C3.98986 3.5 3.82029 3.57024 3.69526 3.69526C3.57024 3.82029 3.5 3.98986 3.5 4.16667V15.8333C3.5 16.0101 3.57024 16.1797 3.69526 16.3047C3.82029 16.4298 3.98986 16.5 4.16667 16.5H7.5C8.05228 16.5 8.5 16.9477 8.5 17.5C8.5 18.0523 8.05228 18.5 7.5 18.5H4.16667C3.45942 18.5 2.78115 18.219 2.28105 17.719C1.78095 17.2189 1.5 16.5406 1.5 15.8333V4.16667C1.5 3.45942 1.78095 2.78115 2.28105 2.28105C2.78115 1.78095 3.45942 1.5 4.16667 1.5H7.5C8.05228 1.5 8.5 1.94772 8.5 2.5C8.5 3.05228 8.05228 3.5 7.5 3.5H4.16667ZM12.6262 5.12623C13.0168 4.7357 13.6499 4.7357 14.0404 5.12623L18.2071 9.29289C18.5976 9.68342 18.5976 10.3166 18.2071 10.7071L14.0404 14.8738C13.6499 15.2643 13.0168 15.2643 12.6262 14.8738C12.2357 14.4832 12.2357 13.8501 12.6262 13.4596L15.0858 11H7.5C6.94772 11 6.5 10.5523 6.5 10C6.5 9.44772 6.94772 9 7.5 9H15.0858L12.6262 6.54044C12.2357 6.14992 12.2357 5.51675 12.6262 5.12623Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const RefreshLeftIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 24 20"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M1 2.00001V8.00001M1 8.00001H7M1 8.00001L5.64 3.64001C6.71475 2.56473 8.04437 1.77922 9.50481 1.35679C10.9652 0.934356 12.5089 0.888766 13.9917 1.22427C15.4745 1.55978 16.8482 2.26545 17.9845 3.27543C19.1209 4.28542 19.9828 5.5668 20.49 7.00001M23 18V12M23 12H17M23 12L18.36 16.36C17.2853 17.4353 15.9556 18.2208 14.4952 18.6432C13.0348 19.0657 11.4911 19.1113 10.0083 18.7758C8.52547 18.4402 7.1518 17.7346 6.01547 16.7246C4.87913 15.7146 4.01717 14.4332 3.51 13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const SeparatorIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 1 18"
      width="1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        fill="currentColor"
        height="18"
        width="1"
      />
    </svg>
  );
};

export const SubsidiaryImgIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0C5.175 0 4.5 0.675 4.5 1.5V22.5C4.5 23.325 5.175 24 6 24H21C21.825 24 22.5 23.325 22.5 22.5V6L16.5 0H6Z"
        fill="#E2E5E7"
      />
      <path
        d="M18 6H22.5L16.5 0V4.5C16.5 5.325 17.175 6 18 6Z"
        fill="#B0B7BD"
      />
      <path
        d="M22.5 10.5L18 6H22.5V10.5Z"
        fill="#CAD1D8"
      />
      <path
        d="M19.5 19.5C19.5 19.9125 19.1625 20.25 18.75 20.25H2.25C1.8375 20.25 1.5 19.9125 1.5 19.5V12C1.5 11.5875 1.8375 11.25 2.25 11.25H18.75C19.1625 11.25 19.5 11.5875 19.5 12V19.5Z"
        fill="#50BEE8"
      />
      <path
        d="M18.75 20.25H4.5V21H18.75C19.1625 21 19.5 20.6625 19.5 20.25V19.5C19.5 19.9125 19.1625 20.25 18.75 20.25Z"
        fill="#CAD1D8"
      />
      <path
        d="M6.01574 17.5143C6.01574 17.6201 5.97575 17.7097 5.89578 17.7829C5.81581 17.8521 5.72322 17.8867 5.61799 17.8867C5.50014 17.8867 5.40544 17.8521 5.33389 17.7829C5.26234 17.7097 5.22656 17.6201 5.22656 17.5143V13.9861C5.22656 13.8803 5.26444 13.7928 5.3402 13.7237C5.41596 13.6504 5.51277 13.6138 5.63062 13.6138C5.73163 13.6138 5.82002 13.6504 5.89578 13.7237C5.97575 13.7928 6.01574 13.8803 6.01574 13.9861V17.5143Z"
        fill="white"
      />
      <path
        d="M7.36296 13.6077C7.42188 13.6077 7.48291 13.6239 7.54605 13.6565C7.61339 13.685 7.6639 13.7237 7.69757 13.7725L9.07591 15.8236L10.4881 13.7725C10.5681 13.6626 10.6712 13.6077 10.7975 13.6077C10.8985 13.6077 10.989 13.6423 11.0689 13.7114C11.1489 13.7806 11.1889 13.8702 11.1889 13.98V17.5143C11.1889 17.6201 11.1531 17.7097 11.0816 17.7829C11.01 17.8521 10.9153 17.8867 10.7975 17.8867C10.6796 17.8867 10.5828 17.8521 10.507 17.7829C10.4355 17.7097 10.3997 17.6201 10.3997 17.5143V15.0571L10.6459 14.6942L9.35799 16.5926C9.32011 16.6374 9.27171 16.676 9.21279 16.7086C9.15807 16.7411 9.10125 16.7554 9.04232 16.7513C8.98761 16.7554 8.93079 16.7411 8.87186 16.7086C8.81715 16.676 8.77085 16.6374 8.73297 16.5926L7.69126 14.8346V14.4256V17.5143C7.69126 17.6201 7.65758 17.7097 7.59024 17.7829C7.5229 17.8521 7.43451 17.8867 7.32508 17.8867C7.21986 17.8867 7.13357 17.8521 7.06623 17.7829C6.99889 17.7097 6.96521 17.6201 6.96521 17.5143V13.98C6.96521 13.8783 7.00309 13.7908 7.07886 13.7175C7.15883 13.6443 7.25353 13.6077 7.36296 13.6077Z"
        fill="white"
      />
      <path
        d="M14.2214 17.9477C13.9016 17.9477 13.6027 17.8908 13.3249 17.7768C13.0471 17.6629 12.803 17.5062 12.5926 17.3068C12.3821 17.1033 12.2159 16.8693 12.0938 16.6048C11.976 16.3403 11.917 16.0554 11.917 15.7502C11.917 15.445 11.976 15.1602 12.0938 14.8956C12.2159 14.6311 12.3821 14.3992 12.5926 14.1998C12.803 13.9963 13.0471 13.8376 13.3249 13.7237C13.6027 13.6097 13.9016 13.5527 14.2214 13.5527C14.4193 13.5527 14.6108 13.5731 14.796 13.6138C14.9811 13.6545 15.1516 13.7155 15.3073 13.7969C15.3705 13.8295 15.4168 13.8742 15.4462 13.9312C15.4799 13.9841 15.4967 14.039 15.4967 14.096C15.4967 14.1937 15.4631 14.2812 15.3957 14.3585C15.3284 14.4358 15.2421 14.4745 15.1369 14.4745C15.1032 14.4745 15.0674 14.4704 15.0296 14.4623C14.9959 14.4541 14.9622 14.4419 14.9285 14.4256C14.8233 14.3809 14.7118 14.3463 14.5939 14.3219C14.4761 14.2974 14.3519 14.2852 14.2214 14.2852C13.9479 14.2852 13.6974 14.3524 13.4701 14.4867C13.2471 14.6169 13.0682 14.7939 12.9335 15.0177C12.803 15.2375 12.7378 15.4816 12.7378 15.7502C12.7378 16.0147 12.803 16.2589 12.9335 16.4827C13.0682 16.7065 13.2471 16.8856 13.4701 17.0199C13.6974 17.1501 13.9479 17.2152 14.2214 17.2152C14.3477 17.2152 14.4866 17.203 14.6381 17.1786C14.7896 17.1542 14.857 17.1371 14.9538 17.0964V17.2641V16.3118H15.0611H14.3603C14.2509 16.3118 14.1583 16.2772 14.0825 16.208C14.011 16.1389 13.9752 16.0514 13.9752 15.9456C13.9752 15.8398 14.011 15.7523 14.0825 15.6831C14.1583 15.6139 14.2509 15.5793 14.3603 15.5793H15.3957C15.5052 15.5793 15.5957 15.6159 15.6672 15.6892C15.7388 15.7584 15.7745 15.8459 15.7745 15.9517V17.2457C15.7745 17.3271 15.7535 17.3943 15.7114 17.4472C15.6735 17.5001 15.6293 17.5428 15.5788 17.5754C15.3852 17.6893 15.1727 17.7809 14.9412 17.8501C14.7139 17.9152 14.474 17.9477 14.2214 17.9477Z"
        fill="white"
      />
    </svg>
  );
};

export const StopIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3.7511 5.16531C2.96443 6.24027 2.5 7.5659 2.5 9C2.5 12.5899 5.41015 15.5 9 15.5C10.4341 15.5 11.7597 15.0356 12.8347 14.2489L3.7511 5.16531ZM5.16531 3.7511L14.2489 12.8347C15.0356 11.7597 15.5 10.4341 15.5 9C15.5 5.41015 12.5899 2.5 9 2.5C7.5659 2.5 6.24027 2.96443 5.16531 3.7511ZM0.5 9C0.5 4.30558 4.30558 0.5 9 0.5C13.6944 0.5 17.5 4.30558 17.5 9C17.5 13.6944 13.6944 17.5 9 17.5C4.30558 17.5 0.5 13.6944 0.5 9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const SubsidiaryPdfIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 40 40"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z"
        fill="#E2E5E7"
      />
      <path
        d="M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z"
        fill="#B0B7BD"
      />
      <path
        d="M37.5 17.5L30 10H37.5V17.5Z"
        fill="#CAD1D8"
      />
      <path
        d="M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z"
        fill="#F15642"
      />
      <path
        d="M7.94876 23.6837C7.94876 23.3537 8.20876 22.9937 8.62751 22.9937H10.9363C12.2363 22.9937 13.4063 23.8637 13.4063 25.5312C13.4063 27.1112 12.2363 27.9912 10.9363 27.9912H9.26751V29.3112C9.26751 29.7512 8.98751 29.9999 8.62751 29.9999C8.29751 29.9999 7.94876 29.7512 7.94876 29.3112V23.6837ZM9.26751 24.2524V26.7424H10.9363C11.6063 26.7424 12.1363 26.1512 12.1363 25.5312C12.1363 24.8324 11.6063 24.2524 10.9363 24.2524H9.26751Z"
        fill="white"
      />
      <path
        d="M15.3638 29.9997C15.0338 29.9997 14.6738 29.8197 14.6738 29.381V23.7035C14.6738 23.3447 15.0338 23.0835 15.3638 23.0835H17.6525C22.22 23.0835 22.12 29.9997 17.7425 29.9997H15.3638ZM15.9938 24.3035V28.781H17.6525C20.3513 28.781 20.4713 24.3035 17.6525 24.3035H15.9938Z"
        fill="white"
      />
      <path
        d="M23.74 24.3836V25.9724H26.2887C26.6487 25.9724 27.0087 26.3324 27.0087 26.6811C27.0087 27.0111 26.6487 27.2811 26.2887 27.2811H23.74V29.3799C23.74 29.7299 23.4912 29.9986 23.1412 29.9986C22.7012 29.9986 22.4325 29.7299 22.4325 29.3799V23.7024C22.4325 23.3436 22.7025 23.0824 23.1412 23.0824H26.65C27.09 23.0824 27.35 23.3436 27.35 23.7024C27.35 24.0224 27.09 24.3824 26.65 24.3824H23.74V24.3836Z"
        fill="white"
      />
      <path
        d="M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z"
        fill="#CAD1D8"
      />
    </svg>
  );
};

export const SquareEmptyIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckedIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
      fill="currentColor"
    />
  </svg>
);

export const SquareCheckedIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 8H16V16H8V8Z"
      fill="currentColor"
    />
    <path
      d="M21 18.4286V5.57143C21 4.15329 19.8467 3 18.4286 3H5.57143C4.15329 3 3 4.15329 3 5.57143V18.4286C3 19.8467 4.15329 21 5.57143 21H18.4286C19.8467 21 21 19.8467 21 18.4286ZM5 5H19V19H5V5Z"
      fill="currentColor"
    />
  </svg>

);

export const EditIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M14.25 2.62891C14.1028 2.62891 13.957 2.65791 13.8209 2.71426C13.6849 2.77061 13.5613 2.85321 13.4571 2.95733L3.51991 12.8946L2.92524 15.075L5.1057 14.4803L15.0429 4.54312C15.147 4.439 15.2296 4.31538 15.286 4.17934C15.3423 4.0433 15.3713 3.89748 15.3713 3.75023C15.3713 3.60297 15.3423 3.45716 15.286 3.32112C15.2296 3.18507 15.147 3.06146 15.0429 2.95733C14.9388 2.85321 14.8152 2.77061 14.6791 2.71426C14.5431 2.65791 14.3973 2.62891 14.25 2.62891ZM13.0555 0.866503C13.4342 0.709641 13.8401 0.628906 14.25 0.628906C14.6599 0.628906 15.0658 0.709641 15.4445 0.866503C15.8232 1.02336 16.1673 1.25328 16.4571 1.54312C16.747 1.83296 16.9769 2.17705 17.1337 2.55575C17.2906 2.93445 17.3713 3.34033 17.3713 3.75023C17.3713 4.16012 17.2906 4.56601 17.1337 4.9447C16.9769 5.3234 16.747 5.66749 16.4571 5.95733L6.33213 16.0823C6.20907 16.2054 6.05604 16.2942 5.88814 16.34L1.76314 17.465C1.41693 17.5594 1.04667 17.4611 0.792916 17.2073C0.539166 16.9536 0.440838 16.5833 0.535259 16.2371L1.66026 12.1121C1.70605 11.9442 1.79486 11.7912 1.91792 11.6681L12.0429 1.54312C12.3328 1.25328 12.6768 1.02336 13.0555 0.866503Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const DownloadCircleIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.29295 0.792893C8.48049 0.605357 8.73484 0.5 9.00006 0.5C10.1163 0.5 11.2216 0.719859 12.2529 1.14702C13.2841 1.57419 14.2212 2.20029 15.0105 2.98959C15.7998 3.77889 16.4259 4.71592 16.853 5.74719C17.2802 6.77846 17.5001 7.88376 17.5001 9C17.5001 9.55229 17.0523 10 16.5001 10H9.00006C8.44777 10 8.00006 9.55229 8.00006 9V1.5C8.00006 1.23478 8.10542 0.98043 8.29295 0.792893ZM10.0001 2.57738V8H15.4227C15.3434 7.49053 15.2035 6.99112 15.0053 6.51256C14.6786 5.72394 14.1998 5.00739 13.5963 4.40381C12.9927 3.80023 12.2761 3.32144 11.4875 2.99478C11.0089 2.79656 10.5095 2.65671 10.0001 2.57738ZM6.91659 1.72254C7.13748 2.22873 6.90621 2.81814 6.40002 3.03903C5.42689 3.46369 4.57261 4.12026 3.91185 4.95135C3.25109 5.78244 2.80398 6.76274 2.60961 7.80654C2.41523 8.85035 2.47951 9.92588 2.79683 10.9391C3.11415 11.9523 3.67484 12.8724 4.42988 13.6189C5.18492 14.3653 6.11133 14.9155 7.12811 15.2212C8.14489 15.5269 9.22109 15.5789 10.2626 15.3726C11.3041 15.1664 12.2792 14.7081 13.1027 14.0379C13.9262 13.3677 14.573 12.5059 14.9865 11.528C15.2016 11.0194 15.7883 10.7814 16.297 10.9965C16.8057 11.2116 17.0437 11.7983 16.8286 12.307C16.2878 13.5858 15.4421 14.7127 14.3652 15.5891C13.2883 16.4655 12.0132 17.0648 10.6512 17.3345C9.28919 17.6043 7.88186 17.5363 6.55222 17.1365C5.22259 16.7367 4.01113 16.0173 3.02377 15.0411C2.0364 14.065 1.30319 12.8618 0.888238 11.5368C0.473286 10.2118 0.389226 8.80538 0.643407 7.44041C0.897587 6.07543 1.48227 4.7935 2.34634 3.70669C3.21041 2.61988 4.32755 1.76129 5.6001 1.20597C6.10629 0.985076 6.6957 1.21635 6.91659 1.72254Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const SquareEditIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M20 2.87891C19.7026 2.87891 19.4174 2.99705 19.2071 3.20733L9.90296 12.5115L9.37437 14.6259L11.4888 14.0973L20.7929 4.79312C21.0032 4.58283 21.1213 4.29762 21.1213 4.00023C21.1213 3.70283 21.0032 3.41762 20.7929 3.20733C20.5826 2.99705 20.2974 2.87891 20 2.87891ZM17.7929 1.79312C18.3783 1.20776 19.1722 0.878906 20 0.878906C20.8278 0.878906 21.6217 1.20776 22.2071 1.79312C22.7925 2.37848 23.1213 3.1724 23.1213 4.00023C23.1213 4.82805 22.7925 5.62197 22.2071 6.20733L12.7071 15.7073C12.5789 15.8355 12.4184 15.9264 12.2425 15.9704L8.24254 16.9704C7.90176 17.0556 7.54127 16.9557 7.29289 16.7073C7.04451 16.459 6.94466 16.0985 7.02986 15.7577L8.02986 11.7577C8.07382 11.5819 8.16473 11.4213 8.29289 11.2931L17.7929 1.79312ZM1.87868 3.87891C2.44129 3.3163 3.20435 3.00023 4 3.00023H11C11.5523 3.00023 12 3.44794 12 4.00023C12 4.55251 11.5523 5.00023 11 5.00023H4C3.73478 5.00023 3.48043 5.10558 3.29289 5.29312C3.10536 5.48066 3 5.73501 3 6.00023V20.0002C3 20.2654 3.10536 20.5198 3.29289 20.7073C3.48043 20.8949 3.73478 21.0002 4 21.0002H18C18.2652 21.0002 18.5196 20.8949 18.7071 20.7073C18.8946 20.5198 19 20.2654 19 20.0002V13.0002C19 12.4479 19.4477 12.0002 20 12.0002C20.5523 12.0002 21 12.4479 21 13.0002V20.0002C21 20.7959 20.6839 21.5589 20.1213 22.1215C19.5587 22.6842 18.7957 23.0002 18 23.0002H4C3.20435 23.0002 2.44129 22.6842 1.87868 22.1215C1.31607 21.5589 1 20.7959 1 20.0002V6.00023C1 5.20458 1.31607 4.44152 1.87868 3.87891Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export const RemoveIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M3.14645 3.14645C3.34171 2.95118 3.65829 2.95118 3.85355 3.14645L7 6.29289L10.1464 3.14645C10.3417 2.95118 10.6583 2.95118 10.8536 3.14645C11.0488 3.34171 11.0488 3.65829 10.8536 3.85355L7.70711 7L10.8536 10.1464C11.0488 10.3417 11.0488 10.6583 10.8536 10.8536C10.6583 11.0488 10.3417 11.0488 10.1464 10.8536L7 7.70711L3.85355 10.8536C3.65829 11.0488 3.34171 11.0488 3.14645 10.8536C2.95118 10.6583 2.95118 10.3417 3.14645 10.1464L6.29289 7L3.14645 3.85355C2.95118 3.65829 2.95118 3.34171 3.14645 3.14645Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const DeleteIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7.5 2.5C7.36739 2.5 7.24022 2.55268 7.14645 2.64645C7.05268 2.74022 7 2.86739 7 3V3.5H11V3C11 2.86739 10.9473 2.74022 10.8536 2.64645C10.7598 2.55268 10.6326 2.5 10.5 2.5H7.5ZM13 3.5V3C13 2.33696 12.7366 1.70107 12.2678 1.23223C11.7989 0.763392 11.163 0.5 10.5 0.5H7.5C6.83696 0.5 6.20107 0.763392 5.73223 1.23223C5.26339 1.70107 5 2.33696 5 3V3.5H3.75H2.25C1.69772 3.5 1.25 3.94772 1.25 4.5C1.25 5.05228 1.69772 5.5 2.25 5.5H2.75V15C2.75 15.663 3.01339 16.2989 3.48223 16.7678C3.95107 17.2366 4.58696 17.5 5.25 17.5H12.75C13.413 17.5 14.0489 17.2366 14.5178 16.7678C14.9866 16.2989 15.25 15.663 15.25 15V5.5H15.75C16.3023 5.5 16.75 5.05228 16.75 4.5C16.75 3.94772 16.3023 3.5 15.75 3.5H14.25H13ZM12 5.5H6H4.75V15C4.75 15.1326 4.80268 15.2598 4.89645 15.3536C4.99022 15.4473 5.11739 15.5 5.25 15.5H12.75C12.8826 15.5 13.0098 15.4473 13.1036 15.3536C13.1973 15.2598 13.25 15.1326 13.25 15V5.5H12ZM7.5 7.25C8.05228 7.25 8.5 7.69772 8.5 8.25V12.75C8.5 13.3023 8.05228 13.75 7.5 13.75C6.94772 13.75 6.5 13.3023 6.5 12.75V8.25C6.5 7.69772 6.94772 7.25 7.5 7.25ZM10.5 7.25C11.0523 7.25 11.5 7.69772 11.5 8.25V12.75C11.5 13.3023 11.0523 13.75 10.5 13.75C9.94772 13.75 9.5 13.3023 9.5 12.75V8.25C9.5 7.69772 9.94772 7.25 10.5 7.25Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const FilterIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5 2.25H1.5L7.5 9.345V14.25L10.5 15.75V9.345L16.5 2.25Z"
      stroke="#606875"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const SearchIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.25 3.25C5.48858 3.25 3.25 5.48858 3.25 8.25C3.25 11.0114 5.48858 13.25 8.25 13.25C9.59091 13.25 10.8085 12.7222 11.7064 11.8629C11.7293 11.8344 11.754 11.8068 11.7804 11.7804C11.8068 11.754 11.8344 11.7293 11.8629 11.7064C12.7222 10.8085 13.25 9.59091 13.25 8.25C13.25 5.48858 11.0114 3.25 8.25 3.25ZM13.8564 12.4422C14.7316 11.2736 15.25 9.82234 15.25 8.25C15.25 4.38401 12.116 1.25 8.25 1.25C4.38401 1.25 1.25 4.38401 1.25 8.25C1.25 12.116 4.38401 15.25 8.25 15.25C9.82234 15.25 11.2736 14.7316 12.4422 13.8564L15.0429 16.4571C15.4334 16.8476 16.0666 16.8476 16.4571 16.4571C16.8476 16.0666 16.8476 15.4334 16.4571 15.0429L13.8564 12.4422Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const UploadIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const CalendarIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="22"
    viewBox="0 0 20 22"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 1V5M6 1V5M1 9H19M3 3H17C18.1046 3 19 3.89543 19 5V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const UnionIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M3.81826 4.58325C3.26386 4.58325 2.7213 4.82509 2.31333 5.27386C1.90391 5.72422 1.66675 6.34441 1.66675 6.99992C1.66675 7.65542 1.90391 8.27562 2.31333 8.72598C2.51558 8.94846 2.75309 9.12211 3.01088 9.23957C3.26852 9.35696 3.54271 9.41658 3.81826 9.41658H5.40917C5.68532 9.41658 5.90917 9.64044 5.90917 9.91658C5.90917 10.1927 5.68532 10.4166 5.40917 10.4166H3.81826C3.39742 10.4166 2.98202 10.3253 2.59626 10.1496C2.21066 9.97387 1.86357 9.71784 1.57339 9.39865C0.988295 8.75505 0.666748 7.89151 0.666748 6.99992C0.666748 6.10833 0.988295 5.24479 1.57339 4.60119C2.15992 3.956 2.96622 3.58325 3.81826 3.58325H5.40917C5.68532 3.58325 5.90917 3.80711 5.90917 4.08325C5.90917 4.35939 5.68532 4.58325 5.40917 4.58325H3.81826ZM8.09099 4.08325C8.09099 3.80711 8.31485 3.58325 8.59099 3.58325H10.1819C10.6027 3.58325 11.0181 3.67451 11.4039 3.85027C11.7895 4.02596 12.1366 4.28199 12.4268 4.60119C12.7169 4.92029 12.9448 5.2966 13.0995 5.70756C13.2542 6.11849 13.3334 6.55751 13.3334 6.99992C13.3334 7.44233 13.2542 7.88135 13.0995 8.29228C12.9448 8.70324 12.7169 9.07955 12.4268 9.39865C12.1366 9.71784 11.7895 9.97387 11.4039 10.1496C11.0181 10.3253 10.6027 10.4166 10.1819 10.4166H8.59099C8.31485 10.4166 8.09099 10.1927 8.09099 9.91658C8.09099 9.64044 8.31485 9.41658 8.59099 9.41658H10.1819C10.4575 9.41658 10.7316 9.35696 10.9893 9.23957C11.2471 9.12211 11.4846 8.94846 11.6868 8.72598C11.8892 8.5034 12.0519 8.23665 12.1637 7.93988C12.2754 7.64308 12.3334 7.32355 12.3334 6.99992C12.3334 6.67629 12.2754 6.35676 12.1637 6.05996C12.0519 5.76319 11.8892 5.49643 11.6868 5.27386C11.4846 5.05138 11.2471 4.87773 10.9893 4.76027C10.7316 4.64288 10.4575 4.58325 10.1819 4.58325H8.59099C8.31485 4.58325 8.09099 4.35939 8.09099 4.08325ZM4.37887 6.99992C4.37887 6.72378 4.60273 6.49992 4.87887 6.49992H9.12129C9.39744 6.49992 9.62129 6.72378 9.62129 6.99992C9.62129 7.27606 9.39744 7.49992 9.12129 7.49992H4.87887C4.60273 7.49992 4.37887 7.27606 4.37887 6.99992Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const CloseIconTemplates = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7 1.66675C4.05448 1.66675 1.66666 4.05456 1.66666 7.00008C1.66666 9.9456 4.05448 12.3334 7 12.3334C9.94552 12.3334 12.3333 9.9456 12.3333 7.00008C12.3333 4.05456 9.94552 1.66675 7 1.66675ZM0.666664 7.00008C0.666664 3.50228 3.50219 0.666748 7 0.666748C10.4978 0.666748 13.3333 3.50228 13.3333 7.00008C13.3333 10.4979 10.4978 13.3334 7 13.3334C3.50219 13.3334 0.666664 10.4979 0.666664 7.00008ZM4.89644 4.89653C5.09171 4.70127 5.40829 4.70127 5.60355 4.89653L7 6.29298L8.39644 4.89653C8.59171 4.70127 8.90829 4.70127 9.10355 4.89653C9.29881 5.09179 9.29881 5.40837 9.10355 5.60363L7.7071 7.00008L9.10355 8.39653C9.29881 8.59179 9.29881 8.90837 9.10355 9.10364C8.90829 9.2989 8.59171 9.2989 8.39644 9.10364L7 7.70719L5.60355 9.10364C5.40829 9.2989 5.09171 9.2989 4.89644 9.10364C4.70118 8.90837 4.70118 8.59179 4.89644 8.39653L6.29289 7.00008L4.89644 5.60363C4.70118 5.40837 4.70118 5.09179 4.89644 4.89653Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const DownloadIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="21"
    viewBox="0 0 21 21"
    width="21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.6665 13.5V17.5C19.6665 18.0304 19.4558 18.5391 19.0807 18.9142C18.7056 19.2893 18.1969 19.5 17.6665 19.5H3.6665C3.13607 19.5 2.62736 19.2893 2.25229 18.9142C1.87722 18.5391 1.6665 18.0304 1.6665 17.5V13.5M5.6665 8.5L10.6665 13.5M10.6665 13.5L15.6665 8.5M10.6665 13.5V1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const PlusIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M8 1V15M1 8H15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
export const SquarePlusIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {

  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 8V16M8.5 12H16.5M5.5 3H19.5C20.6046 3 21.5 3.89543 21.5 5V19C21.5 20.1046 20.6046 21 19.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V5C3.5 3.89543 4.39543 3 5.5 3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export const NotificationIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 18 20"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M10.4417 17.5C10.2952 17.7526 10.0849 17.9622 9.83185 18.1079C9.57884 18.2537 9.29198 18.3304 9 18.3304C8.70802 18.3304 8.42116 18.2537 8.16814 18.1079C7.91513 17.9622 7.70484 17.7526 7.55833 17.5M14 6.66666C14 5.34057 13.4732 4.0688 12.5355 3.13112C11.5979 2.19344 10.3261 1.66666 9 1.66666C7.67392 1.66666 6.40215 2.19344 5.46447 3.13112C4.52678 4.0688 4 5.34057 4 6.66666C4 12.5 1.5 14.1667 1.5 14.1667H16.5C16.5 14.1667 14 12.5 14 6.66666Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const MessengerIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;

  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
export const CheckCircleIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {

  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.64713 14.5242L10.0007 14.8764L10.3536 14.5236L16.5887 8.28836L17.2941 8.99875L10 16.2929L6.70711 13L7.41068 12.2964L9.64713 14.5242ZM2.5 12C2.5 6.75614 6.75614 2.5 12 2.5C17.2439 2.5 21.5 6.75614 21.5 12C21.5 17.2439 17.2439 21.5 12 21.5C6.75614 21.5 2.5 17.2439 2.5 12ZM3.5 12C3.5 16.6861 7.31386 20.5 12 20.5C16.6861 20.5 20.5 16.6861 20.5 12C20.5 7.31386 16.6861 3.5 12 3.5C7.31386 3.5 3.5 7.31386 3.5 12Z"
        fill="black"
        fillOpacity="0.54"
        stroke="currentColor"
      />
    </svg>

  );
};

export const UploadIcon2 = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 15.9997H14.5C15.05 15.9997 15.5 15.5497 15.5 14.9997V9.99973H17.09C17.98 9.99973 18.43 8.91973 17.8 8.28973L13.21 3.69973C12.82 3.30973 12.19 3.30973 11.8 3.69973L7.21 8.28973C6.58 8.91973 7.02 9.99973 7.91 9.99973H9.5V14.9997C9.5 15.5497 9.95 15.9997 10.5 15.9997ZM6.5 17.9997H18.5C19.05 17.9997 19.5 18.4497 19.5 18.9997C19.5 19.5497 19.05 19.9997 18.5 19.9997H6.5C5.95 19.9997 5.5 19.5497 5.5 18.9997C5.5 18.4497 5.95 17.9997 6.5 17.9997Z"
      fill="currentColor"
    />
  </svg>
);

export const ReloadIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 12 16"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 1.9999V0.657401C6 0.319901 5.595 0.154901 5.3625 0.394901L3.2625 2.4874C3.1125 2.6374 3.1125 2.8699 3.2625 3.0199L5.355 5.1124C5.595 5.3449 6 5.1799 6 4.8424V3.4999C8.4825 3.4999 10.5 5.5174 10.5 7.9999C10.5 8.5924 10.3875 9.1699 10.17 9.6874C10.0575 9.9574 10.14 10.2649 10.3425 10.4674C10.725 10.8499 11.37 10.7149 11.5725 10.2124C11.85 9.5299 12 8.7799 12 7.9999C12 4.6849 9.315 1.9999 6 1.9999ZM6 12.4999C3.5175 12.4999 1.5 10.4824 1.5 7.9999C1.5 7.4074 1.6125 6.8299 1.83 6.3124C1.9425 6.0424 1.86 5.7349 1.6575 5.5324C1.275 5.1499 0.63 5.2849 0.4275 5.7874C0.15 6.4699 0 7.2199 0 7.9999C0 11.3149 2.685 13.9999 6 13.9999V15.3424C6 15.6799 6.405 15.8449 6.6375 15.6049L8.73 13.5124C8.88 13.3624 8.88 13.1299 8.73 12.9799L6.6375 10.8874C6.405 10.6549 6 10.8199 6 11.1574V12.4999Z"
      fill="currentColor"
    />
  </svg>
);

export const WarningIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;
  return (
    <svg
      fill="none"
      height="34"
      viewBox="0 0 34 34"
      width="34"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M17.0006 12.75V18.4167M17.0006 24.0834H17.0147M14.5781 5.46838L2.57891 25.5C2.33152 25.9285 2.20062 26.4142 2.19923 26.9089C2.19784 27.4037 2.32602 27.8901 2.57102 28.32C2.81601 28.7498 3.16927 29.1079 3.59567 29.3588C4.02206 29.6097 4.50671 29.7446 5.00141 29.75H28.9997C29.4944 29.7446 29.9791 29.6097 30.4055 29.3588C30.8319 29.1079 31.1852 28.7498 31.4301 28.32C31.6751 27.8901 31.8033 27.4037 31.8019 26.9089C31.8005 26.4142 31.6696 25.9285 31.4222 25.5L19.4231 5.46838C19.1705 5.05203 18.8149 4.7078 18.3906 4.4689C17.9663 4.23 17.4875 4.10449 17.0006 4.10449C16.5136 4.10449 16.0349 4.23 15.6106 4.4689C15.1862 4.7078 14.8306 5.05203 14.5781 5.46838Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const ClearIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M2.79289 2.79289C3.18342 2.40237 3.81658 2.40237 4.20711 2.79289L7 5.58579L9.79289 2.79289C10.1834 2.40237 10.8166 2.40237 11.2071 2.79289C11.5976 3.18342 11.5976 3.81658 11.2071 4.20711L8.41421 7L11.2071 9.79289C11.5976 10.1834 11.5976 10.8166 11.2071 11.2071C10.8166 11.5976 10.1834 11.5976 9.79289 11.2071L7 8.41421L4.20711 11.2071C3.81658 11.5976 3.18342 11.5976 2.79289 11.2071C2.40237 10.8166 2.40237 10.1834 2.79289 9.79289L5.58579 7L2.79289 4.20711C2.40237 3.81658 2.40237 3.18342 2.79289 2.79289Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const SortIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement> & { asc?: boolean, desc?: boolean }) => {
  const { asc, desc, ...restProps } = props;
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <rect
        height="24"
        rx="2"
        width="24"
      />
      <path
        d="M8 14L12 18L16 14"
        stroke={desc ? 'currentColor' : '#D9DDE1'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M16 10L12 6L8 10"
        stroke={asc ? 'currentColor' : '#D9DDE1'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export const LeftArrow = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { strokeWidth = '2', ...restProps } = props;
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M15 8H1M1 8L8 15M1 8L8 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const ProgressIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M1.19922 6L3.23922 7.17796C3.65799 6.45061 4.17228 5.78449 4.77473 5.18204C5.66126 4.29551 6.69228 3.6 7.84085 3.1151C9.02861 2.61306 10.2898 2.35837 11.5927 2.35837C12.8955 2.35837 14.1592 2.61306 15.3445 3.1151C16.4931 3.6 17.5241 4.29551 18.4106 5.18204C19.2972 6.06857 19.9927 7.09959 20.4776 8.24816C20.9821 9.43347 21.2368 10.6971 21.2368 12C21.2368 13.3029 20.9821 14.5665 20.48 15.7518C19.9951 16.9004 19.2996 17.9314 18.4131 18.818C17.5266 19.7045 16.4955 20.4 15.347 20.8849C14.1592 21.3869 12.898 21.6416 11.5951 21.6416C10.7551 21.6416 9.92493 21.5339 9.12167 21.3233C8.34534 21.1176 7.5935 20.8139 6.89065 20.4196C5.50452 19.6433 4.31677 18.5241 3.46208 17.182C3.38616 17.062 3.31269 16.942 3.24167 16.8196L1.19922 18C1.28738 18.1543 1.38044 18.3037 1.4735 18.4531C3.60657 21.7886 7.34126 24 11.5927 24C18.2196 24 23.5927 18.6269 23.5927 12C23.5927 5.37306 18.2196 0 11.5927 0C7.15269 0 3.2735 2.41224 1.19922 6Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const EditorIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 14 12"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M10.4992 1.97915C10.3832 1.97915 10.272 2.02524 10.1899 2.10727L3.05494 9.24225L2.84873 10.0671L3.67357 9.86088L10.8085 2.7259C10.8492 2.68528 10.8814 2.63706 10.9034 2.58399C10.9254 2.53091 10.9367 2.47403 10.9367 2.41659C10.9367 2.35914 10.9254 2.30226 10.9034 2.24919C10.8814 2.19612 10.8492 2.14789 10.8085 2.10727C10.7679 2.06665 10.7197 2.03443 10.6666 2.01245C10.6136 1.99047 10.5567 1.97915 10.4992 1.97915ZM9.05855 0.975902C9.44064 0.593808 9.95887 0.37915 10.4992 0.37915C10.7668 0.37915 11.0317 0.43185 11.2789 0.534241C11.5261 0.636632 11.7507 0.786708 11.9399 0.975902C12.1291 1.1651 12.2792 1.3897 12.3816 1.63689C12.484 1.88409 12.5367 2.14903 12.5367 2.41659C12.5367 2.68415 12.484 2.94909 12.3816 3.19628C12.2792 3.44347 12.1291 3.66808 11.9399 3.85727L4.64825 11.1489C4.54573 11.2515 4.41726 11.3242 4.2766 11.3594L1.94326 11.9427C1.67064 12.0109 1.38225 11.931 1.18355 11.7323C0.984846 11.5336 0.904967 11.2452 0.973122 10.9726L1.55646 8.63923C1.59162 8.49856 1.66436 8.3701 1.76688 8.26757L9.05855 0.975902ZM6.19924 11.1666C6.19924 10.7248 6.55741 10.3666 6.99924 10.3666H12.2492C12.6911 10.3666 13.0492 10.7248 13.0492 11.1666C13.0492 11.6084 12.6911 11.9666 12.2492 11.9666H6.99924C6.55741 11.9666 6.19924 11.6084 6.19924 11.1666Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const EuroIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 15.4167C10.4083 15.4167 8.6 14.2333 7.7 12.5H11.6667C12.125 12.5 12.5 12.125 12.5 11.6667C12.5 11.2083 12.125 10.8333 11.6667 10.8333H7.15C7.10833 10.5583 7.08333 10.2833 7.08333 10C7.08333 9.71667 7.10833 9.44167 7.15 9.16667H11.6667C12.125 9.16667 12.5 8.79167 12.5 8.33333C12.5 7.875 12.125 7.5 11.6667 7.5H7.7C8.6 5.76667 10.4167 4.58333 12.5 4.58333C13.5417 4.58333 14.5167 4.88333 15.35 5.39167C15.7667 5.65 16.3083 5.60833 16.6583 5.25833C17.1417 4.775 17.0333 3.98333 16.45 3.625C15.3 2.91667 13.9417 2.5 12.5 2.5C9.23333 2.5 6.46667 4.59167 5.43333 7.5H3.33333C2.875 7.5 2.5 7.875 2.5 8.33333C2.5 8.79167 2.875 9.16667 3.33333 9.16667H5.05C5.01667 9.44167 5 9.71667 5 10C5 10.2833 5.01667 10.5583 5.05 10.8333H3.33333C2.875 10.8333 2.5 11.2083 2.5 11.6667C2.5 12.125 2.875 12.5 3.33333 12.5H5.43333C6.46667 15.4083 9.23333 17.5 12.5 17.5C13.95 17.5 15.3 17.0917 16.45 16.375C17.025 16.0167 17.1333 15.2167 16.65 14.7333C16.3 14.3833 15.7583 14.3417 15.3417 14.6083C14.5167 15.125 13.55 15.4167 12.5 15.4167Z"
        fill="currentColor"
      />
    </svg>

  );
};

export const AppStoreIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="43"
      viewBox="0 0 146 43"
      width="146"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.6018 27.924C29.2607 28.7275 28.8569 29.4672 28.3891 30.1473C27.7514 31.0743 27.2292 31.716 26.8268 32.0724C26.2031 32.6573 25.5347 32.9569 24.8191 32.9739C24.3053 32.9739 23.6857 32.8248 22.9645 32.5224C22.2409 32.2214 21.5759 32.0724 20.9678 32.0724C20.3301 32.0724 19.6462 32.2214 18.9147 32.5224C18.182 32.8248 17.5918 32.9824 17.1405 32.998C16.4543 33.0278 15.7702 32.7198 15.0874 32.0724C14.6516 31.6848 14.1065 31.0204 13.4535 30.0791C12.7528 29.0739 12.1768 27.9084 11.7256 26.5795C11.2423 25.1442 11 23.7543 11 22.4087C11 20.8673 11.3266 19.5379 11.9809 18.4239C12.4951 17.529 13.1792 16.8231 14.0353 16.305C14.8915 15.7868 15.8166 15.5227 16.8128 15.5058C17.3579 15.5058 18.0727 15.6777 18.961 16.0156C19.8469 16.3547 20.4156 16.5266 20.665 16.5266C20.8514 16.5266 21.4833 16.3255 22.5544 15.9248C23.5674 15.5531 24.4222 15.3992 25.1226 15.4598C27.0204 15.616 28.4461 16.3788 29.3943 17.7531C27.6971 18.8017 26.8575 20.2703 26.8742 22.1544C26.8895 23.622 27.4116 24.8432 28.4378 25.8129C28.9028 26.2629 29.4222 26.6108 30 26.8578C29.8747 27.2283 29.7424 27.5833 29.6018 27.924V27.924ZM25.2493 10.4601C25.2493 11.6104 24.8372 12.6844 24.0157 13.6785C23.0243 14.8603 21.8253 15.5431 20.5249 15.4354C20.5075 15.2908 20.4988 15.1452 20.4987 14.9995C20.4987 13.8953 20.9702 12.7135 21.8074 11.7472C22.2254 11.258 22.757 10.8512 23.4017 10.5267C24.0449 10.2071 24.6534 10.0303 25.2256 10C25.2424 10.1538 25.2493 10.3076 25.2493 10.4601V10.4601Z"
        fill="black"
      />
      <path
        d="M42.1992 11H41.0117L41.0195 10.3867H42.1992C42.6055 10.3867 42.944 10.3021 43.2148 10.1328C43.4857 9.96094 43.6888 9.72135 43.8242 9.41406C43.9622 9.10417 44.0312 8.74219 44.0312 8.32812V7.98047C44.0312 7.65495 43.9922 7.36589 43.9141 7.11328C43.8359 6.85807 43.7214 6.64323 43.5703 6.46875C43.4193 6.29167 43.2344 6.15755 43.0156 6.06641C42.7995 5.97526 42.5508 5.92969 42.2695 5.92969H40.9883V5.3125H42.2695C42.6419 5.3125 42.9818 5.375 43.2891 5.5C43.5964 5.6224 43.8607 5.80078 44.082 6.03516C44.306 6.26693 44.4779 6.54818 44.5977 6.87891C44.7174 7.20703 44.7773 7.57682 44.7773 7.98828V8.32812C44.7773 8.73958 44.7174 9.11068 44.5977 9.44141C44.4779 9.76953 44.3047 10.0495 44.0781 10.2812C43.8542 10.513 43.5833 10.6914 43.2656 10.8164C42.9505 10.9388 42.5951 11 42.1992 11ZM41.4141 5.3125V11H40.6602V5.3125H41.4141ZM45.6094 8.93359V8.84375C45.6094 8.53906 45.6536 8.25651 45.7422 7.99609C45.8307 7.73307 45.9583 7.50521 46.125 7.3125C46.2917 7.11719 46.4935 6.96615 46.7305 6.85938C46.9674 6.75 47.2331 6.69531 47.5273 6.69531C47.8242 6.69531 48.0911 6.75 48.3281 6.85938C48.5677 6.96615 48.7708 7.11719 48.9375 7.3125C49.1068 7.50521 49.2357 7.73307 49.3242 7.99609C49.4128 8.25651 49.457 8.53906 49.457 8.84375V8.93359C49.457 9.23828 49.4128 9.52083 49.3242 9.78125C49.2357 10.0417 49.1068 10.2695 48.9375 10.4648C48.7708 10.6576 48.569 10.8086 48.332 10.918C48.0977 11.0247 47.832 11.0781 47.5352 11.0781C47.2383 11.0781 46.9714 11.0247 46.7344 10.918C46.4974 10.8086 46.2943 10.6576 46.125 10.4648C45.9583 10.2695 45.8307 10.0417 45.7422 9.78125C45.6536 9.52083 45.6094 9.23828 45.6094 8.93359ZM46.332 8.84375V8.93359C46.332 9.14453 46.3568 9.34375 46.4062 9.53125C46.4557 9.71615 46.5299 9.88021 46.6289 10.0234C46.7305 10.1667 46.8568 10.2799 47.0078 10.3633C47.1589 10.444 47.3346 10.4844 47.5352 10.4844C47.7331 10.4844 47.9062 10.444 48.0547 10.3633C48.2057 10.2799 48.3307 10.1667 48.4297 10.0234C48.5286 9.88021 48.6029 9.71615 48.6523 9.53125C48.7044 9.34375 48.7305 9.14453 48.7305 8.93359V8.84375C48.7305 8.63542 48.7044 8.4388 48.6523 8.25391C48.6029 8.06641 48.5273 7.90104 48.4258 7.75781C48.3268 7.61198 48.2018 7.4974 48.0508 7.41406C47.9023 7.33073 47.7279 7.28906 47.5273 7.28906C47.3294 7.28906 47.1549 7.33073 47.0039 7.41406C46.8555 7.4974 46.7305 7.61198 46.6289 7.75781C46.5299 7.90104 46.4557 8.06641 46.4062 8.25391C46.3568 8.4388 46.332 8.63542 46.332 8.84375ZM51.4336 10.25L52.5195 6.77344H52.9961L52.9023 7.46484L51.7969 11H51.332L51.4336 10.25ZM50.7031 6.77344L51.6289 10.2891L51.6953 11H51.207L49.9805 6.77344H50.7031ZM54.0352 10.2617L54.918 6.77344H55.6367L54.4102 11H53.9258L54.0352 10.2617ZM53.1016 6.77344L54.1641 10.1914L54.2852 11H53.8242L52.6875 7.45703L52.5938 6.77344H53.1016ZM57.1016 7.67578V11H56.3789V6.77344H57.0625L57.1016 7.67578ZM56.9297 8.72656L56.6289 8.71484C56.6315 8.42578 56.6745 8.15885 56.7578 7.91406C56.8411 7.66667 56.9583 7.45182 57.1094 7.26953C57.2604 7.08724 57.4401 6.94661 57.6484 6.84766C57.8594 6.74609 58.0924 6.69531 58.3477 6.69531C58.556 6.69531 58.7435 6.72396 58.9102 6.78125C59.0768 6.83594 59.2188 6.92448 59.3359 7.04688C59.4557 7.16927 59.5469 7.32812 59.6094 7.52344C59.6719 7.71615 59.7031 7.95182 59.7031 8.23047V11H58.9766V8.22266C58.9766 8.0013 58.944 7.82422 58.8789 7.69141C58.8138 7.55599 58.7188 7.45833 58.5938 7.39844C58.4688 7.33594 58.3151 7.30469 58.1328 7.30469C57.9531 7.30469 57.7891 7.34245 57.6406 7.41797C57.4948 7.49349 57.3685 7.59766 57.2617 7.73047C57.1576 7.86328 57.0755 8.01562 57.0156 8.1875C56.9583 8.35677 56.9297 8.53646 56.9297 8.72656ZM61.5859 5V11H60.8594V5H61.5859ZM62.5547 8.93359V8.84375C62.5547 8.53906 62.599 8.25651 62.6875 7.99609C62.776 7.73307 62.9036 7.50521 63.0703 7.3125C63.237 7.11719 63.4388 6.96615 63.6758 6.85938C63.9128 6.75 64.1784 6.69531 64.4727 6.69531C64.7695 6.69531 65.0365 6.75 65.2734 6.85938C65.513 6.96615 65.7161 7.11719 65.8828 7.3125C66.0521 7.50521 66.181 7.73307 66.2695 7.99609C66.3581 8.25651 66.4023 8.53906 66.4023 8.84375V8.93359C66.4023 9.23828 66.3581 9.52083 66.2695 9.78125C66.181 10.0417 66.0521 10.2695 65.8828 10.4648C65.7161 10.6576 65.5143 10.8086 65.2773 10.918C65.043 11.0247 64.7773 11.0781 64.4805 11.0781C64.1836 11.0781 63.9167 11.0247 63.6797 10.918C63.4427 10.8086 63.2396 10.6576 63.0703 10.4648C62.9036 10.2695 62.776 10.0417 62.6875 9.78125C62.599 9.52083 62.5547 9.23828 62.5547 8.93359ZM63.2773 8.84375V8.93359C63.2773 9.14453 63.3021 9.34375 63.3516 9.53125C63.401 9.71615 63.4753 9.88021 63.5742 10.0234C63.6758 10.1667 63.8021 10.2799 63.9531 10.3633C64.1042 10.444 64.2799 10.4844 64.4805 10.4844C64.6784 10.4844 64.8516 10.444 65 10.3633C65.151 10.2799 65.276 10.1667 65.375 10.0234C65.474 9.88021 65.5482 9.71615 65.5977 9.53125C65.6497 9.34375 65.6758 9.14453 65.6758 8.93359V8.84375C65.6758 8.63542 65.6497 8.4388 65.5977 8.25391C65.5482 8.06641 65.4727 7.90104 65.3711 7.75781C65.2721 7.61198 65.1471 7.4974 64.9961 7.41406C64.8477 7.33073 64.6732 7.28906 64.4727 7.28906C64.2747 7.28906 64.1003 7.33073 63.9492 7.41406C63.8008 7.4974 63.6758 7.61198 63.5742 7.75781C63.4753 7.90104 63.401 8.06641 63.3516 8.25391C63.3021 8.4388 63.2773 8.63542 63.2773 8.84375ZM69.8008 10.2773V8.10156C69.8008 7.9349 69.7669 7.79036 69.6992 7.66797C69.6341 7.54297 69.5352 7.44661 69.4023 7.37891C69.2695 7.3112 69.1055 7.27734 68.9102 7.27734C68.7279 7.27734 68.5677 7.30859 68.4297 7.37109C68.2943 7.43359 68.1875 7.51562 68.1094 7.61719C68.0339 7.71875 67.9961 7.82812 67.9961 7.94531H67.2734C67.2734 7.79427 67.3125 7.64453 67.3906 7.49609C67.4688 7.34766 67.5807 7.21354 67.7266 7.09375C67.875 6.97135 68.0521 6.875 68.2578 6.80469C68.4661 6.73177 68.6979 6.69531 68.9531 6.69531C69.2604 6.69531 69.5312 6.7474 69.7656 6.85156C70.0026 6.95573 70.1875 7.11328 70.3203 7.32422C70.4557 7.53255 70.5234 7.79427 70.5234 8.10938V10.0781C70.5234 10.2188 70.5352 10.3685 70.5586 10.5273C70.5846 10.6862 70.6224 10.8229 70.6719 10.9375V11H69.918C69.8815 10.9167 69.8529 10.806 69.832 10.668C69.8112 10.5273 69.8008 10.3971 69.8008 10.2773ZM69.9258 8.4375L69.9336 8.94531H69.2031C68.9974 8.94531 68.8138 8.96224 68.6523 8.99609C68.4909 9.02734 68.3555 9.07552 68.2461 9.14062C68.1367 9.20573 68.0534 9.28776 67.9961 9.38672C67.9388 9.48307 67.9102 9.59635 67.9102 9.72656C67.9102 9.85938 67.9401 9.98047 68 10.0898C68.0599 10.1992 68.1497 10.2865 68.2695 10.3516C68.3919 10.4141 68.5417 10.4453 68.7188 10.4453C68.9401 10.4453 69.1354 10.3984 69.3047 10.3047C69.474 10.2109 69.6081 10.0964 69.707 9.96094C69.8086 9.82552 69.8633 9.69401 69.8711 9.56641L70.1797 9.91406C70.1615 10.0234 70.112 10.1445 70.0312 10.2773C69.9505 10.4102 69.8424 10.5378 69.707 10.6602C69.5742 10.7799 69.4154 10.8802 69.2305 10.9609C69.0482 11.0391 68.8424 11.0781 68.6133 11.0781C68.3268 11.0781 68.0755 11.0221 67.8594 10.9102C67.6458 10.7982 67.4792 10.6484 67.3594 10.4609C67.2422 10.2708 67.1836 10.0586 67.1836 9.82422C67.1836 9.59766 67.2279 9.39844 67.3164 9.22656C67.4049 9.05208 67.5326 8.90755 67.6992 8.79297C67.8659 8.67578 68.0664 8.58724 68.3008 8.52734C68.5352 8.46745 68.7969 8.4375 69.0859 8.4375H69.9258ZM74.3242 10.1797V5H75.0508V11H74.3867L74.3242 10.1797ZM71.4805 8.93359V8.85156C71.4805 8.52865 71.5195 8.23568 71.5977 7.97266C71.6784 7.70703 71.7917 7.47917 71.9375 7.28906C72.0859 7.09896 72.2617 6.95312 72.4648 6.85156C72.6706 6.7474 72.8997 6.69531 73.1523 6.69531C73.418 6.69531 73.6497 6.74219 73.8477 6.83594C74.0482 6.92708 74.2174 7.0612 74.3555 7.23828C74.4961 7.41276 74.6068 7.6237 74.6875 7.87109C74.7682 8.11849 74.8242 8.39844 74.8555 8.71094V9.07031C74.8268 9.38021 74.7708 9.65885 74.6875 9.90625C74.6068 10.1536 74.4961 10.3646 74.3555 10.5391C74.2174 10.7135 74.0482 10.8477 73.8477 10.9414C73.6471 11.0326 73.4128 11.0781 73.1445 11.0781C72.8971 11.0781 72.6706 11.0247 72.4648 10.918C72.2617 10.8112 72.0859 10.6615 71.9375 10.4688C71.7917 10.276 71.6784 10.0495 71.5977 9.78906C71.5195 9.52604 71.4805 9.24089 71.4805 8.93359ZM72.207 8.85156V8.93359C72.207 9.14453 72.2279 9.34245 72.2695 9.52734C72.3138 9.71224 72.3815 9.875 72.4727 10.0156C72.5638 10.1562 72.6797 10.2669 72.8203 10.3477C72.9609 10.4258 73.1289 10.4648 73.3242 10.4648C73.5638 10.4648 73.7604 10.4141 73.9141 10.3125C74.0703 10.2109 74.1953 10.0768 74.2891 9.91016C74.3828 9.74349 74.4557 9.5625 74.5078 9.36719V8.42578C74.4766 8.28255 74.431 8.14453 74.3711 8.01172C74.3138 7.8763 74.2383 7.75651 74.1445 7.65234C74.0534 7.54557 73.9401 7.46094 73.8047 7.39844C73.6719 7.33594 73.5143 7.30469 73.332 7.30469C73.1341 7.30469 72.9635 7.34635 72.8203 7.42969C72.6797 7.51042 72.5638 7.6224 72.4727 7.76562C72.3815 7.90625 72.3138 8.07031 72.2695 8.25781C72.2279 8.44271 72.207 8.64062 72.207 8.85156ZM77.9688 8.93359V8.84375C77.9688 8.53906 78.013 8.25651 78.1016 7.99609C78.1901 7.73307 78.3177 7.50521 78.4844 7.3125C78.651 7.11719 78.8529 6.96615 79.0898 6.85938C79.3268 6.75 79.5924 6.69531 79.8867 6.69531C80.1836 6.69531 80.4505 6.75 80.6875 6.85938C80.9271 6.96615 81.1302 7.11719 81.2969 7.3125C81.4661 7.50521 81.5951 7.73307 81.6836 7.99609C81.7721 8.25651 81.8164 8.53906 81.8164 8.84375V8.93359C81.8164 9.23828 81.7721 9.52083 81.6836 9.78125C81.5951 10.0417 81.4661 10.2695 81.2969 10.4648C81.1302 10.6576 80.9284 10.8086 80.6914 10.918C80.457 11.0247 80.1914 11.0781 79.8945 11.0781C79.5977 11.0781 79.3307 11.0247 79.0938 10.918C78.8568 10.8086 78.6536 10.6576 78.4844 10.4648C78.3177 10.2695 78.1901 10.0417 78.1016 9.78125C78.013 9.52083 77.9688 9.23828 77.9688 8.93359ZM78.6914 8.84375V8.93359C78.6914 9.14453 78.7161 9.34375 78.7656 9.53125C78.8151 9.71615 78.8893 9.88021 78.9883 10.0234C79.0898 10.1667 79.2161 10.2799 79.3672 10.3633C79.5182 10.444 79.694 10.4844 79.8945 10.4844C80.0924 10.4844 80.2656 10.444 80.4141 10.3633C80.5651 10.2799 80.6901 10.1667 80.7891 10.0234C80.888 9.88021 80.9622 9.71615 81.0117 9.53125C81.0638 9.34375 81.0898 9.14453 81.0898 8.93359V8.84375C81.0898 8.63542 81.0638 8.4388 81.0117 8.25391C80.9622 8.06641 80.8867 7.90104 80.7852 7.75781C80.6862 7.61198 80.5612 7.4974 80.4102 7.41406C80.2617 7.33073 80.0872 7.28906 79.8867 7.28906C79.6888 7.28906 79.5143 7.33073 79.3633 7.41406C79.2148 7.4974 79.0898 7.61198 78.9883 7.75781C78.8893 7.90104 78.8151 8.06641 78.7656 8.25391C78.7161 8.4388 78.6914 8.63542 78.6914 8.84375ZM83.4453 7.67578V11H82.7227V6.77344H83.4062L83.4453 7.67578ZM83.2734 8.72656L82.9727 8.71484C82.9753 8.42578 83.0182 8.15885 83.1016 7.91406C83.1849 7.66667 83.3021 7.45182 83.4531 7.26953C83.6042 7.08724 83.7839 6.94661 83.9922 6.84766C84.2031 6.74609 84.4362 6.69531 84.6914 6.69531C84.8997 6.69531 85.0872 6.72396 85.2539 6.78125C85.4206 6.83594 85.5625 6.92448 85.6797 7.04688C85.7995 7.16927 85.8906 7.32812 85.9531 7.52344C86.0156 7.71615 86.0469 7.95182 86.0469 8.23047V11H85.3203V8.22266C85.3203 8.0013 85.2878 7.82422 85.2227 7.69141C85.1576 7.55599 85.0625 7.45833 84.9375 7.39844C84.8125 7.33594 84.6589 7.30469 84.4766 7.30469C84.2969 7.30469 84.1328 7.34245 83.9844 7.41797C83.8385 7.49349 83.7122 7.59766 83.6055 7.73047C83.5013 7.86328 83.4193 8.01562 83.3594 8.1875C83.3021 8.35677 83.2734 8.53646 83.2734 8.72656ZM90.8984 6.77344V7.32812H88.6133V6.77344H90.8984ZM89.3867 5.74609H90.1094V9.95312C90.1094 10.0964 90.1315 10.2044 90.1758 10.2773C90.2201 10.3503 90.2773 10.3984 90.3477 10.4219C90.418 10.4453 90.4935 10.457 90.5742 10.457C90.6341 10.457 90.6966 10.4518 90.7617 10.4414C90.8294 10.4284 90.8802 10.418 90.9141 10.4102L90.918 11C90.8607 11.0182 90.7852 11.0352 90.6914 11.0508C90.6003 11.069 90.4896 11.0781 90.3594 11.0781C90.1823 11.0781 90.0195 11.043 89.8711 10.9727C89.7227 10.9023 89.6042 10.7852 89.5156 10.6211C89.4297 10.4544 89.3867 10.2305 89.3867 9.94922V5.74609ZM92.4688 5V11H91.7461V5H92.4688ZM92.2969 8.72656L91.9961 8.71484C91.9987 8.42578 92.0417 8.15885 92.125 7.91406C92.2083 7.66667 92.3255 7.45182 92.4766 7.26953C92.6276 7.08724 92.8073 6.94661 93.0156 6.84766C93.2266 6.74609 93.4596 6.69531 93.7148 6.69531C93.9232 6.69531 94.1107 6.72396 94.2773 6.78125C94.444 6.83594 94.5859 6.92448 94.7031 7.04688C94.8229 7.16927 94.9141 7.32812 94.9766 7.52344C95.0391 7.71615 95.0703 7.95182 95.0703 8.23047V11H94.3438V8.22266C94.3438 8.0013 94.3112 7.82422 94.2461 7.69141C94.181 7.55599 94.0859 7.45833 93.9609 7.39844C93.8359 7.33594 93.6823 7.30469 93.5 7.30469C93.3203 7.30469 93.1562 7.34245 93.0078 7.41797C92.862 7.49349 92.7357 7.59766 92.6289 7.73047C92.5247 7.86328 92.4427 8.01562 92.3828 8.1875C92.3255 8.35677 92.2969 8.53646 92.2969 8.72656ZM97.9062 11.0781C97.612 11.0781 97.3451 11.0286 97.1055 10.9297C96.8685 10.8281 96.6641 10.6862 96.4922 10.5039C96.3229 10.3216 96.1927 10.1055 96.1016 9.85547C96.0104 9.60547 95.9648 9.33203 95.9648 9.03516V8.87109C95.9648 8.52734 96.0156 8.22135 96.1172 7.95312C96.2188 7.68229 96.3568 7.45312 96.5312 7.26562C96.7057 7.07812 96.9036 6.9362 97.125 6.83984C97.3464 6.74349 97.5755 6.69531 97.8125 6.69531C98.1146 6.69531 98.375 6.7474 98.5938 6.85156C98.8151 6.95573 98.9961 7.10156 99.1367 7.28906C99.2773 7.47396 99.3815 7.69271 99.4492 7.94531C99.5169 8.19531 99.5508 8.46875 99.5508 8.76562V9.08984H96.3945V8.5H98.8281V8.44531C98.8177 8.25781 98.7786 8.07552 98.7109 7.89844C98.6458 7.72135 98.5417 7.57552 98.3984 7.46094C98.2552 7.34635 98.0599 7.28906 97.8125 7.28906C97.6484 7.28906 97.4974 7.32422 97.3594 7.39453C97.2214 7.46224 97.1029 7.5638 97.0039 7.69922C96.9049 7.83464 96.8281 8 96.7734 8.19531C96.7188 8.39062 96.6914 8.61589 96.6914 8.87109V9.03516C96.6914 9.23568 96.7188 9.42448 96.7734 9.60156C96.8307 9.77604 96.9128 9.92969 97.0195 10.0625C97.1289 10.1953 97.2604 10.2995 97.4141 10.375C97.5703 10.4505 97.7474 10.4883 97.9453 10.4883C98.2005 10.4883 98.4167 10.4362 98.5938 10.332C98.7708 10.2279 98.9258 10.0885 99.0586 9.91406L99.4961 10.2617C99.4049 10.3997 99.2891 10.5312 99.1484 10.6562C99.0078 10.7812 98.8346 10.8828 98.6289 10.9609C98.4258 11.0391 98.1849 11.0781 97.9062 11.0781Z"
        fill="black"
      />
      <path
        d="M40.2539 34H42.5488L43.8477 30.1914H49.2773L50.5664 34H52.8613L47.7441 19.9082H45.3809L40.2539 34ZM46.543 22.2422H46.582L48.6816 28.4336H44.4336L46.543 22.2422ZM54.1699 37.418H56.2793V32.2715H56.3281C56.9336 33.4629 58.1152 34.2051 59.5703 34.2051C62.1484 34.2051 63.8379 32.1445 63.8379 28.873V28.8633C63.8379 25.582 62.1582 23.5312 59.541 23.5312C58.0762 23.5312 56.9434 24.2734 56.3281 25.4941H56.2793V23.7266H54.1699V37.418ZM58.9941 32.3887C57.4023 32.3887 56.2695 31.002 56.2695 28.873V28.8633C56.2695 26.7246 57.3926 25.3379 58.9941 25.3379C60.6445 25.3379 61.6895 26.6758 61.6895 28.8633V28.873C61.6895 31.041 60.6543 32.3887 58.9941 32.3887ZM65.4785 37.418H67.5879V32.2715H67.6367C68.2422 33.4629 69.4238 34.2051 70.8789 34.2051C73.457 34.2051 75.1465 32.1445 75.1465 28.873V28.8633C75.1465 25.582 73.4668 23.5312 70.8496 23.5312C69.3848 23.5312 68.252 24.2734 67.6367 25.4941H67.5879V23.7266H65.4785V37.418ZM70.3027 32.3887C68.7109 32.3887 67.5781 31.002 67.5781 28.873V28.8633C67.5781 26.7246 68.7012 25.3379 70.3027 25.3379C71.9531 25.3379 72.998 26.6758 72.998 28.8633V28.873C72.998 31.041 71.9629 32.3887 70.3027 32.3887ZM85.9082 34.2344C89.248 34.2344 91.2793 32.6035 91.2793 30.0352V30.0254C91.2793 27.8477 90.0293 26.666 87.1191 26.0508L85.5762 25.7285C83.8184 25.3477 83.0176 24.7031 83.0176 23.6484V23.6387C83.0176 22.4082 84.1309 21.5781 85.8789 21.5684C87.5488 21.5684 88.6816 22.3594 88.877 23.668L88.8867 23.8047H91.0156L91.0059 23.6387C90.8594 21.2754 88.8477 19.6738 85.9082 19.6738C82.9297 19.6738 80.8105 21.3242 80.8008 23.7266V23.7363C80.8008 25.8262 82.1387 27.0957 84.9023 27.6816L86.4355 28.0039C88.3008 28.4141 89.0723 29.0293 89.0723 30.1621V30.1719C89.0723 31.4902 87.8809 32.3398 85.9961 32.3398C84.1113 32.3398 82.8125 31.5293 82.6172 30.2305L82.5977 30.1035H80.4688L80.4785 30.25C80.6543 32.7305 82.7441 34.2344 85.9082 34.2344ZM96.6016 34.2051C97.0312 34.2051 97.4316 34.1562 97.6758 34.1172V32.4863C97.5195 32.5059 97.334 32.5254 97.1094 32.5254C96.2207 32.5254 95.752 32.2129 95.752 31.168V25.4062H97.6758V23.7266H95.752V21.0508H93.5938V23.7266H92.1191V25.4062H93.5938V31.2949C93.5938 33.3457 94.5703 34.2051 96.6016 34.2051ZM103.584 34.2051C106.523 34.2051 108.457 32.1738 108.457 28.8633V28.8438C108.457 25.5527 106.504 23.5312 103.574 23.5312C100.654 23.5312 98.7109 25.5625 98.7109 28.8438V28.8633C98.7109 32.1641 100.635 34.2051 103.584 34.2051ZM103.594 32.4375C101.943 32.4375 100.869 31.1387 100.869 28.8633V28.8438C100.869 26.5977 101.953 25.2988 103.574 25.2988C105.225 25.2988 106.299 26.5977 106.299 28.8438V28.8633C106.299 31.1289 105.244 32.4375 103.594 32.4375ZM110.088 34H112.197V27.877C112.197 26.3438 113.037 25.4551 114.395 25.4551C114.805 25.4551 115.176 25.5039 115.342 25.5723V23.6094C115.176 23.5801 114.912 23.5312 114.609 23.5312C113.438 23.5312 112.578 24.2832 112.246 25.4844H112.197V23.7266H110.088V34ZM120.586 34.2051C123.076 34.2051 124.658 32.7207 124.99 31.0898L125.01 30.9824H123.008L122.979 31.0605C122.715 31.832 121.885 32.4766 120.635 32.4766C118.955 32.4766 117.891 31.3438 117.852 29.4004H125.127V28.6875C125.127 25.6016 123.359 23.5312 120.479 23.5312C117.598 23.5312 115.742 25.6797 115.742 28.8926V28.9023C115.742 32.1445 117.568 34.2051 120.586 34.2051ZM120.488 25.2598C121.865 25.2598 122.861 26.1289 123.037 27.9062H117.881C118.066 26.1875 119.121 25.2598 120.488 25.2598Z"
        fill="#333538"
      />
      <rect
        height="42"
        rx="3.5"
        stroke="#333538"
        width="145"
        x="0.5"
        y="0.5"
      />
    </svg>
  );
};

export const GoogleStoreIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="43"
      viewBox="0 0 146 43"
      width="146"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M10.6168 10.8651C10.3702 11.1301 10.2285 11.5379 10.2285 12.0679V30.9201C10.2285 31.4501 10.3702 31.8579 10.626 32.1137L10.6928 32.1702L21.2561 21.6069V21.3696L10.6836 10.8086L10.6168 10.8651Z"
        fill="url(#paint0_linear_9235_103506)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M24.7705 25.1414L21.2471 21.6168V21.3702L24.7716 17.8457L24.8477 17.8929L29.0163 20.2618C30.2099 20.9347 30.2099 22.0431 29.0163 22.7252L24.8477 25.0941C24.8465 25.0941 24.7705 25.1414 24.7705 25.1414Z"
        fill="url(#paint1_linear_9235_103506)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M24.8462 25.0938L21.2468 21.4932L10.6167 32.1233C11.005 32.5404 11.6583 32.5876 12.3888 32.1797L24.8462 25.0938Z"
        fill="url(#paint2_linear_9235_103506)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M24.8462 17.894L12.3888 10.8173C11.6594 10.4002 11.005 10.4566 10.6167 10.8737L21.2456 21.4935L24.8462 17.894Z"
        fill="url(#paint3_linear_9235_103506)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M24.7703 25.0186L12.398 32.0481C11.7067 32.4456 11.0903 32.4179 10.6928 32.0573L10.626 32.1241L10.6928 32.1806C11.0903 32.54 11.7067 32.5689 12.398 32.1713L24.8555 25.0946L24.7703 25.0186Z"
        fill="black"
        fillRule="evenodd"
        opacity="0.2"
      />
      <path
        clipRule="evenodd"
        d="M29.0151 22.6016L24.7612 25.0177L24.8373 25.0938L29.0059 22.7249C29.6027 22.3838 29.8965 21.9391 29.8965 21.4932C29.8585 21.901 29.5555 22.2893 29.0151 22.6016Z"
        fill="black"
        fillRule="evenodd"
        opacity="0.12"
      />
      <path
        clipRule="evenodd"
        d="M12.3889 10.9407L29.015 20.3864C29.5553 20.6894 29.8584 21.0869 29.9056 21.4948C29.9056 21.05 29.6118 20.6041 29.015 20.2631L12.3889 10.8174C11.1952 10.1353 10.2285 10.7034 10.2285 12.0675V12.1908C10.2285 10.8266 11.1952 10.2678 12.3889 10.9407Z"
        fill="white"
        fillRule="evenodd"
        opacity="0.25"
      />
      <path
        d="M42.1992 13H41.0117L41.0195 12.3867H42.1992C42.6055 12.3867 42.944 12.3021 43.2148 12.1328C43.4857 11.9609 43.6888 11.7214 43.8242 11.4141C43.9622 11.1042 44.0312 10.7422 44.0312 10.3281V9.98047C44.0312 9.65495 43.9922 9.36589 43.9141 9.11328C43.8359 8.85807 43.7214 8.64323 43.5703 8.46875C43.4193 8.29167 43.2344 8.15755 43.0156 8.06641C42.7995 7.97526 42.5508 7.92969 42.2695 7.92969H40.9883V7.3125H42.2695C42.6419 7.3125 42.9818 7.375 43.2891 7.5C43.5964 7.6224 43.8607 7.80078 44.082 8.03516C44.306 8.26693 44.4779 8.54818 44.5977 8.87891C44.7174 9.20703 44.7773 9.57682 44.7773 9.98828V10.3281C44.7773 10.7396 44.7174 11.1107 44.5977 11.4414C44.4779 11.7695 44.3047 12.0495 44.0781 12.2812C43.8542 12.513 43.5833 12.6914 43.2656 12.8164C42.9505 12.9388 42.5951 13 42.1992 13ZM41.4141 7.3125V13H40.6602V7.3125H41.4141ZM45.6094 10.9336V10.8438C45.6094 10.5391 45.6536 10.2565 45.7422 9.99609C45.8307 9.73307 45.9583 9.50521 46.125 9.3125C46.2917 9.11719 46.4935 8.96615 46.7305 8.85938C46.9674 8.75 47.2331 8.69531 47.5273 8.69531C47.8242 8.69531 48.0911 8.75 48.3281 8.85938C48.5677 8.96615 48.7708 9.11719 48.9375 9.3125C49.1068 9.50521 49.2357 9.73307 49.3242 9.99609C49.4128 10.2565 49.457 10.5391 49.457 10.8438V10.9336C49.457 11.2383 49.4128 11.5208 49.3242 11.7812C49.2357 12.0417 49.1068 12.2695 48.9375 12.4648C48.7708 12.6576 48.569 12.8086 48.332 12.918C48.0977 13.0247 47.832 13.0781 47.5352 13.0781C47.2383 13.0781 46.9714 13.0247 46.7344 12.918C46.4974 12.8086 46.2943 12.6576 46.125 12.4648C45.9583 12.2695 45.8307 12.0417 45.7422 11.7812C45.6536 11.5208 45.6094 11.2383 45.6094 10.9336ZM46.332 10.8438V10.9336C46.332 11.1445 46.3568 11.3438 46.4062 11.5312C46.4557 11.7161 46.5299 11.8802 46.6289 12.0234C46.7305 12.1667 46.8568 12.2799 47.0078 12.3633C47.1589 12.444 47.3346 12.4844 47.5352 12.4844C47.7331 12.4844 47.9062 12.444 48.0547 12.3633C48.2057 12.2799 48.3307 12.1667 48.4297 12.0234C48.5286 11.8802 48.6029 11.7161 48.6523 11.5312C48.7044 11.3438 48.7305 11.1445 48.7305 10.9336V10.8438C48.7305 10.6354 48.7044 10.4388 48.6523 10.2539C48.6029 10.0664 48.5273 9.90104 48.4258 9.75781C48.3268 9.61198 48.2018 9.4974 48.0508 9.41406C47.9023 9.33073 47.7279 9.28906 47.5273 9.28906C47.3294 9.28906 47.1549 9.33073 47.0039 9.41406C46.8555 9.4974 46.7305 9.61198 46.6289 9.75781C46.5299 9.90104 46.4557 10.0664 46.4062 10.2539C46.3568 10.4388 46.332 10.6354 46.332 10.8438ZM51.4336 12.25L52.5195 8.77344H52.9961L52.9023 9.46484L51.7969 13H51.332L51.4336 12.25ZM50.7031 8.77344L51.6289 12.2891L51.6953 13H51.207L49.9805 8.77344H50.7031ZM54.0352 12.2617L54.918 8.77344H55.6367L54.4102 13H53.9258L54.0352 12.2617ZM53.1016 8.77344L54.1641 12.1914L54.2852 13H53.8242L52.6875 9.45703L52.5938 8.77344H53.1016ZM57.1016 9.67578V13H56.3789V8.77344H57.0625L57.1016 9.67578ZM56.9297 10.7266L56.6289 10.7148C56.6315 10.4258 56.6745 10.1589 56.7578 9.91406C56.8411 9.66667 56.9583 9.45182 57.1094 9.26953C57.2604 9.08724 57.4401 8.94661 57.6484 8.84766C57.8594 8.74609 58.0924 8.69531 58.3477 8.69531C58.556 8.69531 58.7435 8.72396 58.9102 8.78125C59.0768 8.83594 59.2188 8.92448 59.3359 9.04688C59.4557 9.16927 59.5469 9.32812 59.6094 9.52344C59.6719 9.71615 59.7031 9.95182 59.7031 10.2305V13H58.9766V10.2227C58.9766 10.0013 58.944 9.82422 58.8789 9.69141C58.8138 9.55599 58.7188 9.45833 58.5938 9.39844C58.4688 9.33594 58.3151 9.30469 58.1328 9.30469C57.9531 9.30469 57.7891 9.34245 57.6406 9.41797C57.4948 9.49349 57.3685 9.59766 57.2617 9.73047C57.1576 9.86328 57.0755 10.0156 57.0156 10.1875C56.9583 10.3568 56.9297 10.5365 56.9297 10.7266ZM61.5859 7V13H60.8594V7H61.5859ZM62.5547 10.9336V10.8438C62.5547 10.5391 62.599 10.2565 62.6875 9.99609C62.776 9.73307 62.9036 9.50521 63.0703 9.3125C63.237 9.11719 63.4388 8.96615 63.6758 8.85938C63.9128 8.75 64.1784 8.69531 64.4727 8.69531C64.7695 8.69531 65.0365 8.75 65.2734 8.85938C65.513 8.96615 65.7161 9.11719 65.8828 9.3125C66.0521 9.50521 66.181 9.73307 66.2695 9.99609C66.3581 10.2565 66.4023 10.5391 66.4023 10.8438V10.9336C66.4023 11.2383 66.3581 11.5208 66.2695 11.7812C66.181 12.0417 66.0521 12.2695 65.8828 12.4648C65.7161 12.6576 65.5143 12.8086 65.2773 12.918C65.043 13.0247 64.7773 13.0781 64.4805 13.0781C64.1836 13.0781 63.9167 13.0247 63.6797 12.918C63.4427 12.8086 63.2396 12.6576 63.0703 12.4648C62.9036 12.2695 62.776 12.0417 62.6875 11.7812C62.599 11.5208 62.5547 11.2383 62.5547 10.9336ZM63.2773 10.8438V10.9336C63.2773 11.1445 63.3021 11.3438 63.3516 11.5312C63.401 11.7161 63.4753 11.8802 63.5742 12.0234C63.6758 12.1667 63.8021 12.2799 63.9531 12.3633C64.1042 12.444 64.2799 12.4844 64.4805 12.4844C64.6784 12.4844 64.8516 12.444 65 12.3633C65.151 12.2799 65.276 12.1667 65.375 12.0234C65.474 11.8802 65.5482 11.7161 65.5977 11.5312C65.6497 11.3438 65.6758 11.1445 65.6758 10.9336V10.8438C65.6758 10.6354 65.6497 10.4388 65.5977 10.2539C65.5482 10.0664 65.4727 9.90104 65.3711 9.75781C65.2721 9.61198 65.1471 9.4974 64.9961 9.41406C64.8477 9.33073 64.6732 9.28906 64.4727 9.28906C64.2747 9.28906 64.1003 9.33073 63.9492 9.41406C63.8008 9.4974 63.6758 9.61198 63.5742 9.75781C63.4753 9.90104 63.401 10.0664 63.3516 10.2539C63.3021 10.4388 63.2773 10.6354 63.2773 10.8438ZM69.8008 12.2773V10.1016C69.8008 9.9349 69.7669 9.79036 69.6992 9.66797C69.6341 9.54297 69.5352 9.44661 69.4023 9.37891C69.2695 9.3112 69.1055 9.27734 68.9102 9.27734C68.7279 9.27734 68.5677 9.30859 68.4297 9.37109C68.2943 9.43359 68.1875 9.51562 68.1094 9.61719C68.0339 9.71875 67.9961 9.82812 67.9961 9.94531H67.2734C67.2734 9.79427 67.3125 9.64453 67.3906 9.49609C67.4688 9.34766 67.5807 9.21354 67.7266 9.09375C67.875 8.97135 68.0521 8.875 68.2578 8.80469C68.4661 8.73177 68.6979 8.69531 68.9531 8.69531C69.2604 8.69531 69.5312 8.7474 69.7656 8.85156C70.0026 8.95573 70.1875 9.11328 70.3203 9.32422C70.4557 9.53255 70.5234 9.79427 70.5234 10.1094V12.0781C70.5234 12.2188 70.5352 12.3685 70.5586 12.5273C70.5846 12.6862 70.6224 12.8229 70.6719 12.9375V13H69.918C69.8815 12.9167 69.8529 12.806 69.832 12.668C69.8112 12.5273 69.8008 12.3971 69.8008 12.2773ZM69.9258 10.4375L69.9336 10.9453H69.2031C68.9974 10.9453 68.8138 10.9622 68.6523 10.9961C68.4909 11.0273 68.3555 11.0755 68.2461 11.1406C68.1367 11.2057 68.0534 11.2878 67.9961 11.3867C67.9388 11.4831 67.9102 11.5964 67.9102 11.7266C67.9102 11.8594 67.9401 11.9805 68 12.0898C68.0599 12.1992 68.1497 12.2865 68.2695 12.3516C68.3919 12.4141 68.5417 12.4453 68.7188 12.4453C68.9401 12.4453 69.1354 12.3984 69.3047 12.3047C69.474 12.2109 69.6081 12.0964 69.707 11.9609C69.8086 11.8255 69.8633 11.694 69.8711 11.5664L70.1797 11.9141C70.1615 12.0234 70.112 12.1445 70.0312 12.2773C69.9505 12.4102 69.8424 12.5378 69.707 12.6602C69.5742 12.7799 69.4154 12.8802 69.2305 12.9609C69.0482 13.0391 68.8424 13.0781 68.6133 13.0781C68.3268 13.0781 68.0755 13.0221 67.8594 12.9102C67.6458 12.7982 67.4792 12.6484 67.3594 12.4609C67.2422 12.2708 67.1836 12.0586 67.1836 11.8242C67.1836 11.5977 67.2279 11.3984 67.3164 11.2266C67.4049 11.0521 67.5326 10.9076 67.6992 10.793C67.8659 10.6758 68.0664 10.5872 68.3008 10.5273C68.5352 10.4674 68.7969 10.4375 69.0859 10.4375H69.9258ZM74.3242 12.1797V7H75.0508V13H74.3867L74.3242 12.1797ZM71.4805 10.9336V10.8516C71.4805 10.5286 71.5195 10.2357 71.5977 9.97266C71.6784 9.70703 71.7917 9.47917 71.9375 9.28906C72.0859 9.09896 72.2617 8.95312 72.4648 8.85156C72.6706 8.7474 72.8997 8.69531 73.1523 8.69531C73.418 8.69531 73.6497 8.74219 73.8477 8.83594C74.0482 8.92708 74.2174 9.0612 74.3555 9.23828C74.4961 9.41276 74.6068 9.6237 74.6875 9.87109C74.7682 10.1185 74.8242 10.3984 74.8555 10.7109V11.0703C74.8268 11.3802 74.7708 11.6589 74.6875 11.9062C74.6068 12.1536 74.4961 12.3646 74.3555 12.5391C74.2174 12.7135 74.0482 12.8477 73.8477 12.9414C73.6471 13.0326 73.4128 13.0781 73.1445 13.0781C72.8971 13.0781 72.6706 13.0247 72.4648 12.918C72.2617 12.8112 72.0859 12.6615 71.9375 12.4688C71.7917 12.276 71.6784 12.0495 71.5977 11.7891C71.5195 11.526 71.4805 11.2409 71.4805 10.9336ZM72.207 10.8516V10.9336C72.207 11.1445 72.2279 11.3424 72.2695 11.5273C72.3138 11.7122 72.3815 11.875 72.4727 12.0156C72.5638 12.1562 72.6797 12.2669 72.8203 12.3477C72.9609 12.4258 73.1289 12.4648 73.3242 12.4648C73.5638 12.4648 73.7604 12.4141 73.9141 12.3125C74.0703 12.2109 74.1953 12.0768 74.2891 11.9102C74.3828 11.7435 74.4557 11.5625 74.5078 11.3672V10.4258C74.4766 10.2826 74.431 10.1445 74.3711 10.0117C74.3138 9.8763 74.2383 9.75651 74.1445 9.65234C74.0534 9.54557 73.9401 9.46094 73.8047 9.39844C73.6719 9.33594 73.5143 9.30469 73.332 9.30469C73.1341 9.30469 72.9635 9.34635 72.8203 9.42969C72.6797 9.51042 72.5638 9.6224 72.4727 9.76562C72.3815 9.90625 72.3138 10.0703 72.2695 10.2578C72.2279 10.4427 72.207 10.6406 72.207 10.8516ZM77.9688 10.9336V10.8438C77.9688 10.5391 78.013 10.2565 78.1016 9.99609C78.1901 9.73307 78.3177 9.50521 78.4844 9.3125C78.651 9.11719 78.8529 8.96615 79.0898 8.85938C79.3268 8.75 79.5924 8.69531 79.8867 8.69531C80.1836 8.69531 80.4505 8.75 80.6875 8.85938C80.9271 8.96615 81.1302 9.11719 81.2969 9.3125C81.4661 9.50521 81.5951 9.73307 81.6836 9.99609C81.7721 10.2565 81.8164 10.5391 81.8164 10.8438V10.9336C81.8164 11.2383 81.7721 11.5208 81.6836 11.7812C81.5951 12.0417 81.4661 12.2695 81.2969 12.4648C81.1302 12.6576 80.9284 12.8086 80.6914 12.918C80.457 13.0247 80.1914 13.0781 79.8945 13.0781C79.5977 13.0781 79.3307 13.0247 79.0938 12.918C78.8568 12.8086 78.6536 12.6576 78.4844 12.4648C78.3177 12.2695 78.1901 12.0417 78.1016 11.7812C78.013 11.5208 77.9688 11.2383 77.9688 10.9336ZM78.6914 10.8438V10.9336C78.6914 11.1445 78.7161 11.3438 78.7656 11.5312C78.8151 11.7161 78.8893 11.8802 78.9883 12.0234C79.0898 12.1667 79.2161 12.2799 79.3672 12.3633C79.5182 12.444 79.694 12.4844 79.8945 12.4844C80.0924 12.4844 80.2656 12.444 80.4141 12.3633C80.5651 12.2799 80.6901 12.1667 80.7891 12.0234C80.888 11.8802 80.9622 11.7161 81.0117 11.5312C81.0638 11.3438 81.0898 11.1445 81.0898 10.9336V10.8438C81.0898 10.6354 81.0638 10.4388 81.0117 10.2539C80.9622 10.0664 80.8867 9.90104 80.7852 9.75781C80.6862 9.61198 80.5612 9.4974 80.4102 9.41406C80.2617 9.33073 80.0872 9.28906 79.8867 9.28906C79.6888 9.28906 79.5143 9.33073 79.3633 9.41406C79.2148 9.4974 79.0898 9.61198 78.9883 9.75781C78.8893 9.90104 78.8151 10.0664 78.7656 10.2539C78.7161 10.4388 78.6914 10.6354 78.6914 10.8438ZM83.4453 9.67578V13H82.7227V8.77344H83.4062L83.4453 9.67578ZM83.2734 10.7266L82.9727 10.7148C82.9753 10.4258 83.0182 10.1589 83.1016 9.91406C83.1849 9.66667 83.3021 9.45182 83.4531 9.26953C83.6042 9.08724 83.7839 8.94661 83.9922 8.84766C84.2031 8.74609 84.4362 8.69531 84.6914 8.69531C84.8997 8.69531 85.0872 8.72396 85.2539 8.78125C85.4206 8.83594 85.5625 8.92448 85.6797 9.04688C85.7995 9.16927 85.8906 9.32812 85.9531 9.52344C86.0156 9.71615 86.0469 9.95182 86.0469 10.2305V13H85.3203V10.2227C85.3203 10.0013 85.2878 9.82422 85.2227 9.69141C85.1576 9.55599 85.0625 9.45833 84.9375 9.39844C84.8125 9.33594 84.6589 9.30469 84.4766 9.30469C84.2969 9.30469 84.1328 9.34245 83.9844 9.41797C83.8385 9.49349 83.7122 9.59766 83.6055 9.73047C83.5013 9.86328 83.4193 10.0156 83.3594 10.1875C83.3021 10.3568 83.2734 10.5365 83.2734 10.7266ZM90.8984 8.77344V9.32812H88.6133V8.77344H90.8984ZM89.3867 7.74609H90.1094V11.9531C90.1094 12.0964 90.1315 12.2044 90.1758 12.2773C90.2201 12.3503 90.2773 12.3984 90.3477 12.4219C90.418 12.4453 90.4935 12.457 90.5742 12.457C90.6341 12.457 90.6966 12.4518 90.7617 12.4414C90.8294 12.4284 90.8802 12.418 90.9141 12.4102L90.918 13C90.8607 13.0182 90.7852 13.0352 90.6914 13.0508C90.6003 13.069 90.4896 13.0781 90.3594 13.0781C90.1823 13.0781 90.0195 13.043 89.8711 12.9727C89.7227 12.9023 89.6042 12.7852 89.5156 12.6211C89.4297 12.4544 89.3867 12.2305 89.3867 11.9492V7.74609ZM92.4688 7V13H91.7461V7H92.4688ZM92.2969 10.7266L91.9961 10.7148C91.9987 10.4258 92.0417 10.1589 92.125 9.91406C92.2083 9.66667 92.3255 9.45182 92.4766 9.26953C92.6276 9.08724 92.8073 8.94661 93.0156 8.84766C93.2266 8.74609 93.4596 8.69531 93.7148 8.69531C93.9232 8.69531 94.1107 8.72396 94.2773 8.78125C94.444 8.83594 94.5859 8.92448 94.7031 9.04688C94.8229 9.16927 94.9141 9.32812 94.9766 9.52344C95.0391 9.71615 95.0703 9.95182 95.0703 10.2305V13H94.3438V10.2227C94.3438 10.0013 94.3112 9.82422 94.2461 9.69141C94.181 9.55599 94.0859 9.45833 93.9609 9.39844C93.8359 9.33594 93.6823 9.30469 93.5 9.30469C93.3203 9.30469 93.1562 9.34245 93.0078 9.41797C92.862 9.49349 92.7357 9.59766 92.6289 9.73047C92.5247 9.86328 92.4427 10.0156 92.3828 10.1875C92.3255 10.3568 92.2969 10.5365 92.2969 10.7266ZM97.9062 13.0781C97.612 13.0781 97.3451 13.0286 97.1055 12.9297C96.8685 12.8281 96.6641 12.6862 96.4922 12.5039C96.3229 12.3216 96.1927 12.1055 96.1016 11.8555C96.0104 11.6055 95.9648 11.332 95.9648 11.0352V10.8711C95.9648 10.5273 96.0156 10.2214 96.1172 9.95312C96.2188 9.68229 96.3568 9.45312 96.5312 9.26562C96.7057 9.07812 96.9036 8.9362 97.125 8.83984C97.3464 8.74349 97.5755 8.69531 97.8125 8.69531C98.1146 8.69531 98.375 8.7474 98.5938 8.85156C98.8151 8.95573 98.9961 9.10156 99.1367 9.28906C99.2773 9.47396 99.3815 9.69271 99.4492 9.94531C99.5169 10.1953 99.5508 10.4688 99.5508 10.7656V11.0898H96.3945V10.5H98.8281V10.4453C98.8177 10.2578 98.7786 10.0755 98.7109 9.89844C98.6458 9.72135 98.5417 9.57552 98.3984 9.46094C98.2552 9.34635 98.0599 9.28906 97.8125 9.28906C97.6484 9.28906 97.4974 9.32422 97.3594 9.39453C97.2214 9.46224 97.1029 9.5638 97.0039 9.69922C96.9049 9.83464 96.8281 10 96.7734 10.1953C96.7188 10.3906 96.6914 10.6159 96.6914 10.8711V11.0352C96.6914 11.2357 96.7188 11.4245 96.7734 11.6016C96.8307 11.776 96.9128 11.9297 97.0195 12.0625C97.1289 12.1953 97.2604 12.2995 97.4141 12.375C97.5703 12.4505 97.7474 12.4883 97.9453 12.4883C98.2005 12.4883 98.4167 12.4362 98.5938 12.332C98.7708 12.2279 98.9258 12.0885 99.0586 11.9141L99.4961 12.2617C99.4049 12.3997 99.2891 12.5312 99.1484 12.6562C99.0078 12.7812 98.8346 12.8828 98.6289 12.9609C98.4258 13.0391 98.1849 13.0781 97.9062 13.0781Z"
        fill="black"
      />
      <path
        d="M117.727 32.2126H119.928V17.5303H117.727L117.727 32.2126ZM137.552 22.8192L135.029 29.1847H134.954L132.335 22.8191H129.964L133.891 31.7161L131.652 36.665H133.949L140 22.8191L137.552 22.8192ZM125.07 30.545C124.348 30.545 123.343 30.1862 123.343 29.298C123.343 28.1648 124.596 27.7303 125.676 27.7303C126.645 27.7303 127.099 27.9381 127.688 28.2218C127.517 29.5815 126.34 30.545 125.07 30.545ZM125.336 22.4979C123.742 22.4979 122.092 23.1971 121.409 24.746L123.362 25.558C123.78 24.746 124.557 24.4812 125.373 24.4812C126.512 24.4812 127.669 25.1616 127.688 26.3705V26.5215C127.289 26.2948 126.436 25.9549 125.392 25.9549C123.287 25.9549 121.142 27.1068 121.142 29.2603C121.142 31.2249 122.869 32.4906 124.804 32.4906C126.284 32.4906 127.099 31.8295 127.612 31.0551H127.688V32.1883H129.812V26.559C129.812 23.9528 127.859 22.4979 125.336 22.4979ZM111.733 24.6064H108.602V19.5737H111.733C113.378 19.5737 114.312 20.9303 114.312 22.09C114.312 23.2278 113.378 24.6064 111.733 24.6064ZM111.676 17.5303H106.402V32.2126H108.602V26.6499H111.676C114.115 26.6499 116.513 24.8914 116.513 22.09C116.513 19.2888 114.115 17.5303 111.676 17.5303ZM82.9168 30.5477C81.3962 30.5477 80.1231 29.2801 80.1231 27.539C80.1231 25.7797 81.3962 24.4928 82.9168 24.4928C84.418 24.4928 85.5962 25.7796 85.5962 27.539C85.5962 29.2801 84.418 30.5477 82.9168 30.5477ZM85.4441 23.6413H85.3681C84.8741 23.0549 83.9235 22.5251 82.7265 22.5251C80.218 22.5251 77.9188 24.7198 77.9188 27.539C77.9188 30.3394 80.218 32.5154 82.7265 32.5154C83.9235 32.5154 84.8741 31.9855 85.3681 31.3803H85.4441V32.0993C85.4441 34.0106 84.418 35.0323 82.7647 35.0323C81.4155 35.0323 80.5793 34.067 80.2369 33.2535L78.3179 34.0482C78.8689 35.3726 80.3323 37 82.7647 37C85.3492 37 87.5346 35.486 87.5346 31.7965V22.8278H85.4441V23.6413ZM89.0547 32.2126H91.2591V17.5297H89.0547V32.2126ZM94.5088 27.3688C94.4517 25.4387 96.0101 24.4551 97.1311 24.4551C98.0059 24.4551 98.7467 24.89 98.9932 25.515L94.5088 27.3688ZM101.35 25.7039C100.932 24.5872 99.6585 22.5251 97.055 22.5251C94.4706 22.5251 92.3234 24.5496 92.3234 27.5202C92.3234 30.3206 94.4517 32.5154 97.3021 32.5154C99.6019 32.5154 100.932 31.1151 101.483 30.3017L99.7729 29.1662C99.2031 29.9989 98.4235 30.5477 97.3021 30.5477C96.181 30.5477 95.383 30.0366 94.8696 29.0341L101.578 26.2714L101.35 25.7039ZM47.9055 24.0578V26.1769H52.9984C52.8463 27.3688 52.4472 28.2391 51.839 28.8447C51.0982 29.5828 49.9389 30.3963 47.9055 30.3963C44.7699 30.3963 42.3186 27.8798 42.3186 24.7578C42.3186 21.6359 44.7699 19.1191 47.9055 19.1191C49.597 19.1191 50.8318 19.7815 51.7441 20.6329L53.2454 19.1383C51.9723 17.9271 50.2808 17 47.9055 17C43.6106 17 40 20.4816 40 24.7578C40 29.0341 43.6106 32.5154 47.9055 32.5154C50.2241 32.5154 51.9723 31.7589 53.3403 30.3394C54.7466 28.9392 55.1839 26.9715 55.1839 25.3823C55.1839 24.89 55.146 24.4363 55.0696 24.0578H47.9055ZM60.9739 30.5477C59.4534 30.5477 58.142 29.2988 58.142 27.5202C58.142 25.7227 59.4534 24.4928 60.9739 24.4928C62.4939 24.4928 63.8053 25.7227 63.8053 27.5202C63.8053 29.2989 62.4939 30.5477 60.9739 30.5477ZM60.9739 22.5251C58.1991 22.5251 55.9376 24.6252 55.9376 27.5202C55.9376 30.3963 58.1991 32.5154 60.9739 32.5154C63.7482 32.5154 66.0097 30.3963 66.0097 27.5202C66.0097 24.6252 63.7482 22.5251 60.9739 22.5251ZM71.9595 30.5477C70.4396 30.5477 69.1281 29.2988 69.1281 27.5202C69.1281 25.7227 70.4396 24.4928 71.9596 24.4928C73.4797 24.4928 74.791 25.7227 74.791 27.5202C74.791 29.2989 73.4796 30.5477 71.9595 30.5477ZM71.9595 22.5251C69.1849 22.5251 66.9239 24.6252 66.9239 27.5202C66.9239 30.3963 69.1849 32.5154 71.9596 32.5154C74.7339 32.5154 76.9955 30.3963 76.9955 27.5202C76.9955 24.6252 74.7339 22.5251 71.9595 22.5251Z"
        fill="#333538"
      />
      <rect
        height="42"
        rx="3.5"
        stroke="#333538"
        width="145"
        x="0.5"
        y="0.5"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_9235_103506"
          x1="20.3076"
          x2="3.38705"
          y1="11.8653"
          y2="16.3738"
        >
          <stop stopColor="#00A0FF"/>
          <stop
            offset="0.007"
            stopColor="#00A1FF"
          />
          <stop
            offset="0.26"
            stopColor="#00BEFF"
          />
          <stop
            offset="0.512"
            stopColor="#00D2FF"
          />
          <stop
            offset="0.76"
            stopColor="#00DFFF"
          />
          <stop
            offset="1"
            stopColor="#00E3FF"
          />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_9235_103506"
          x1="30.5696"
          x2="9.93858"
          y1="21.4941"
          y2="21.4941"
        >
          <stop stopColor="#FFE000"/>
          <stop
            offset="0.409"
            stopColor="#FFBD00"
          />
          <stop
            offset="0.775"
            stopColor="#FFA500"
          />
          <stop
            offset="1"
            stopColor="#FF9C00"
          />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_9235_103506"
          x1="22.889"
          x2="9.3051"
          y1="23.4519"
          y2="46.3144"
        >
          <stop stopColor="#FF3A44"/>
          <stop
            offset="1"
            stopColor="#C31162"
          />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_9235_103506"
          x1="7.94084"
          x2="14.001"
          y1="4.59338"
          y2="14.8042"
        >
          <stop stopColor="#32A071"/>
          <stop
            offset="0.069"
            stopColor="#2DA771"
          />
          <stop
            offset="0.476"
            stopColor="#15CF74"
          />
          <stop
            offset="0.801"
            stopColor="#06E775"
          />
          <stop
            offset="1"
            stopColor="#00F076"
          />
        </linearGradient>
      </defs>
    </svg>

  );
};

export const InProgressIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 10 16"
      width="10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5 0.5L0.5075 5L3.5 8L0.5075 11.0075L0.5 15.5H9.5V11L6.5 8L9.5 5.0075V0.5H0.5ZM8 11.375V14H2V11.375L5 8.375L8 11.375Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const InfoIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 22 22"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.083 6.41683H11.9163V8.25016H10.083V6.41683ZM10.083 10.0835H11.9163V15.5835H10.083V10.0835ZM10.9997 1.8335C5.93967 1.8335 1.83301 5.94016 1.83301 11.0002C1.83301 16.0602 5.93967 20.1668 10.9997 20.1668C16.0597 20.1668 20.1663 16.0602 20.1663 11.0002C20.1663 5.94016 16.0597 1.8335 10.9997 1.8335ZM10.9997 18.3335C6.95717 18.3335 3.66634 15.0427 3.66634 11.0002C3.66634 6.95766 6.95717 3.66683 10.9997 3.66683C15.0422 3.66683 18.333 6.95766 18.333 11.0002C18.333 15.0427 15.0422 18.3335 10.9997 18.3335Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SendIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M22.7071 1.29292C22.9788 1.56456 23.0708 1.96779 22.9439 2.33038L15.9439 22.3304C15.8084 22.7174 15.4504 22.9825 15.0408 22.9992C14.6311 23.0159 14.2527 22.7808 14.0862 22.4062L10.2424 13.7576L1.59387 9.91384C1.21919 9.74731 0.984122 9.36894 1.00084 8.95926C1.01755 8.54959 1.28265 8.19162 1.66965 8.05617L21.6697 1.05617C22.0322 0.929264 22.4355 1.02128 22.7071 1.29292ZM12.1928 13.2215L14.8894 19.289L19.6085 5.80571L12.1928 13.2215ZM18.1943 4.3915L4.71108 9.11063L10.7785 11.8073L18.1943 4.3915Z"
      fill="currentColor"
      fillRule="evenodd"/>
  </svg>
);

export const CheckIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="13"
      viewBox="0 0 18 13"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.50063 10.17L2.03063 6.70001C1.64063 6.31001 1.01063 6.31001 0.620625 6.70001C0.230625 7.09001 0.230625 7.72001 0.620625 8.11001L4.80063 12.29C5.19063 12.68 5.82063 12.68 6.21063 12.29L16.7906 1.71001C17.1806 1.32001 17.1806 0.690007 16.7906 0.300007C16.4006 -0.0899927 15.7706 -0.0899927 15.3806 0.300007L5.50063 10.17Z"
        fill="currentColor"
      />
    </svg>
  );
};
